import React, { forwardRef } from 'react';
import { connect } from 'react-redux';
import { setDeleteAction } from 'store/actions/deleteAction';
import cookies from 'utils/cookies';
import http from 'utils/http';
import moment from 'moment-timezone';
import cloneDeep from 'lodash/cloneDeep';
import styles from '../../../../../custom/style.module.css';
import fltLoadInfoStyles from './fltloadinfo.module.css';
import { contractType/*, discrepancyType*/, pageHandler } from 'custom/constants';
import { getStationDate } from 'utils/converter';
import FlightLoadInfo from './FlightLoadInfo';
// import * as XLSX from 'xlsx-js-style';
// import { saveAs } from 'file-saver';
import { toast } from 'react-toastify';
import { handleExport } from '../exportExcel';

// const station = cookies.get('station_code') || null;
// const timezone = cookies.get('timezone') || null;

export class FlightLoadInfoContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // contract_Type: null,
      // cont_item: null,
      // airlines: [],
      // searchFields: {
      //   // from: moment().tz(timezone).format('YYYY-MM-DD'),
      //   // to: moment().add(1,'days').tz(timezone).format('YYYY-MM-DD'),
      //   month: moment().tz(timezone).format('YYYY-MM'),
      //   period: 'month',
      //   airline: null
      // },
      genInvProgress: false,
      billingExists: false,
      userContractTypes: this.props.userContractTypes,
      contract_Type: this.props.contract_Type,
      cont_item: this.props.cont_item,
      airlines: this.props.airlines,
      combinationAirline: this.props.combinationAirline,
      searchFields: this.props.searchFields,
      loadInfo: this.props.loadInfo,
      airlineCode: this.props.airlineCode,
      customReportOptions: [],
      tonSumOpts: [],
      flightSumOpts: [],
      flightDetOpts: [],
      DiscrepancyOptions: [],

      disOpts: [],
      modal: false,
      action: null,

      invoicedata: [],
      flightData: [],
      flight: [],
      flightDetails: [],
      showflightDetails: false,
      flightID: null,
      flightFields: {},
      flightErrors: {},

      flightStatus: {},
      // startDate: moment('2023-10-03 11:11:00', 'YYYY-MM-DD HH:mm:ss'),
      // endDate: moment('2023-10-04 10:10:00', 'YYYY-MM-DD HH:mm:ss'),
      // difference: {},
      flightList: [],
      billingData: [],
      csvContracts: [],
      filteredData: [],
      billingColumns: [],
      prodkeys: [],
      prodkeysDisc: [],
      billingFields: { dateType: 'actual' },
      manifestDate: false,

      expanded: '',
      // loadInfo: 'contract_data',
      flightdata: [],
      daylogdata: [],
      monthlogdata: [],
      alcontractsData: [],
      contractData: [],
      transit_awbs: [],
      transitAWBsModal: false,
      contractLabel: '',
      contractQty: 0,
      contractEqualizedQty: 0,
      dayContractData: [],
      monthContractData: [],
      invoice_info: null,
      accord_id: null,
      accord_type: null,
      summaryData: [],
      showSummary: true,
      billingCol: [],
      modalOpen: false,
      flightReportData: '',
      discrepancyCount: 0,
      progress: 10,
      showOneOff: false,
      oneOffData: [],
      oneOffEdit: {
        index: null,
        id: null,
        label: '',
        amount: '',
        operation: '',
        cycle: '',
      },
      timer: null,
      sessionExpired: false,
      emailPassword: false,
      popoverData: {},
      collapse: [],
      filterData: { },
      filteredBillingData: [],
      reportFields: { reportType: 'full' },
      expandedFlight: false,
      transitAWBType: 'transit',
      statisticsSummary: false,
    };
    this.station_code = cookies.get('station_code') || null;
    this.interval = null;
    this.unmounted = false;
  }

  async componentDidMount() {
    this.unmounted = false;
    await this.fetchManifestDate();
    if (this.unmounted) return;
    try {
      const billingExists = await this.checkBillingExists();
      if (!billingExists) {
        return;
      }
    } catch (error) {
      console.error('Error checking billing exists:', error);
      return;
    }

    this.startTimer();
    this.getConfig();
    // this.fetchAirlineCombination();
    this.fetchDiscrepancies('count');
    const currentPath = window.location.pathname;
    await pageHandler(currentPath, cookies.get('role'));
    // this.eventSource = events('admin', 'method');
    // this.fetchUser();
    if (this.state.searchFields.airline) {
      this.fetchOneOff();
      if (this.state.loadInfo === 'statistics_summary') {
        this.fetchProducts();
      } else if (this.state.loadInfo === 'contract_data' || this.state.loadInfo === 'statistics') {
        this.fetchInvoiceData();
      } else if (this.state.loadInfo === 'discrepancy') {
        this.fetchDiscrepancies();
      }
    }
    // this.fetchAirlines();
  }


  // Clear the timer when the component unmount

  componentWillUnmount() {
    this.unmounted = true;
    // this.eventSource.close();
  }

  // componentDidUpdate(prevProps) {
  //   if (prevProps.progress !== this.props.progress) {
  //     this.setState({ displayProgress: this.props.progress });
  //   }
  // }

  checkBillingExists = async () => {
    this.setState({ billingExists: false });
    const { month, airline } = this.state.searchFields;
    if( !month || !airline)
      return false;
    const type = this.state.cont_item;
    if (typeof type !== 'string' || !type.trim()) {
      throw new Error('Cannot check billing existence without a non-empty contract type');
    }
    //convert month to YYYY_MM format
    let formatMonth = moment(month).format('YYYY_MM');
    const { data } = await http.get('/contract/billing_exists', {
      params: {
        month: formatMonth,
        airlineIds: airline,
        type: type
      }
    });
    if (data?.status !== 'success' || typeof data.data !== 'boolean') {
      throw new Error('Invalid billing exists response: expected a boolean');
    }
    return new Promise((resolve) => {
      this.setState({ billingExists: data.data }, () => resolve(data.data));
    });
  };

  getConfig = () => {
    http.get('/settings?key=statistics_summary').then(({ data }) => {
      if(data.data) {
        let Summary = data.data?.find((item) => item.key === 'statistics_summary');
        if(Summary) {
          this.setState({ statisticsSummary: Summary?.value && Summary.value?.data === 'true'? true: false });
        }
      }
    });
  };

  fetchManifestDate = () => {
    return http.get('/settings?key=manifest_date', { headers: { hideloader: true } })
      .then(({ data }) => {
        if (this.unmounted) return;
        const setting = data.data?.find((item) => item.key === 'manifest_date');
        return new Promise((resolve) => {
          this.setState({ manifestDate: setting?.value?.data === 'true' }, resolve);
        });
      })
      .catch(error => {
        console.error('Error fetching manifest date setting:', error);
      });
  };

  // fetchAirlineCombination = () => {
  //   http.get('/airline_combination?type=all')
  //     .then((response) => {
  //       const { data } = response;
  //       this.setState({ combinationAirline: data.data });
  //     });
  // };

  fetchProducts = ( callType=null, callback) => {
    if(!callType || this.state.billingColumns.length === 0){
      this.setState({
        products: [],
        activeProd: null,
      });
      const airline = this.state.searchFields?.airline;
      const airlineId = typeof airline === 'string' ? airline.split(',')[0] : airline;
      http.get(`/products?airlineId=${airlineId}`)
        .then(response => {
          const { data } = response;
          if (data.status === 'success') {
            if (data.data && data.data.length > 0) {
              this.setState({
                products: data.data,
                activeProd: data.data[0],
              }, () => {
                this.generateBillingColumns(callType,'fetch', (v) => {
                  console.log('generateBillingColumns', v);
                  return callback && callback(true, this.state.billingData, this.state.billingColumns);
                });
              });
            } else {
              this.setState({
                activeProd: null,
                products: []
              }, () => {
                this.generateBillingColumns(callType, 'fetch', (v) => {
                  console.log('generateBillingColumns', v);
                  return callback && callback(true, this.state.billingData, this.state.billingColumns);
                });
              });
            }
          }
        })
        .catch(error => {
          this.setState({ products: [] });
          console.error('Error fetching data:', error);
          return callback && callback(false);
        });
    } else {
      return callback && callback(true, this.state.billingData, this.state.billingColumns);
    }
  };

  fetchBillingReport = (callType, callback) => {
    const getFlightAirlineCode = (flight, airline) => (
      flight?.airline?.code ||
      (typeof flight?.airline === 'string' ? flight.airline : null) ||
      this.state.airlines?.find((item) => String(item.id) === String(flight?.airlineId))?.code ||
      airline?.code
    );
    let from = this.state.searchFields.from;
    let to = this.state.searchFields.to;
    if (this.state.searchFields.month) {
      if (this.state.searchFields.period === 'month') {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
      } else if (this.state.searchFields.period === 'first') {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').add(14, 'days').format('YYYY-MM-DD');
      } else {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').add(15, 'days').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
      }
    }
    let dateType = 'actual';
    if(this.state.billingFields.dateType === 'scheduled'){
      dateType = 'scheduled';
    }
    if (from && to && this.state.searchFields.airline) {
      http.get(`/billing?from=${from}&to=${to}&station=${this.station_code}&airline=${this.state.searchFields.airline}&type=${this.state.cont_item}&datetype=${dateType}`)
        .then(({ data }) => {
          this.setState({ flightList: data.data });
          if (data.data && data.data.length > 0) {
            let billingData = [];
            data.data.forEach((airline) => {

              let inbound = {};
              let outbound = {};
              let inbound_data = [];
              let outbound_data = [];

              let ib_flight_count = 0;
              let ib_awb_count = 0;
              let ib_awb_count_disc = 0;
              let ib_sum_awb_local = 0;
              let ib_sum_awb_local_disc = 0;
              let ib_sum_awb_export = 0;
              let ib_sum_awb_export_disc = 0;
              let ib_sum_awb_transit = 0;
              let ib_sum_awb_transit_disc = 0;
              let ib_sum_awb_bup = 0;
              let ib_sum_awb_comat = 0;
              let ib_sum_manifested = 0;
              let ib_prodvals = cloneDeep(this.state.prodkeys).map((rec) => {
                return {
                  key: rec.key,
                  id: rec.id,
                  sum: 0
                };
              });
              let ib_prodvals_disc = cloneDeep(this.state.prodkeysDisc).map((rec) => {
                return {
                  key: rec.key,
                  id: rec.id,
                  sum: 0
                };
              });

              let ib_awbs = [];
              let ob_awbs = [];

              if (airline?.inbound?.length > 0) {
                ib_flight_count = airline?.inbound?.filter((inflight) => {
                  return inflight.status === 'Finalized' || inflight.status === 'Pending' || inflight.status === 'Approved';
                }).length;
                airline?.inbound.map((inflight) => {
                  console.log('inflight.status', inflight.status);
                  let addtocalc = false;
                  if (inflight.status === 'Finalized' || inflight.status === 'Pending' || inflight.status === 'Approved') {
                    addtocalc = true;
                  }
                  let distinct_awbs = [];
                  let flight_discrepancies = inflight?.flight_discrepancies || [];
                  let awb_count = 0;
                  let awb_count_disc = 0;
                  let sum_awb_local = 0;
                  let sum_awb_local_disc = 0;
                  let sum_awb_export = 0;
                  let sum_awb_export_disc = 0;
                  let sum_awb_transit = 0;
                  let sum_awb_transit_disc = 0;
                  let sum_awb_bup = 0;
                  let sum_awb_comat = 0;
                  let sum_manifested = 0;
                  let sum_prodvals = cloneDeep(this.state.prodkeys).map((rec) => {
                    return {
                      key: rec.key,
                      id: rec.id,
                      sum: 0
                    };
                  });
                  let sum_prodvals_disc = cloneDeep(this.state.prodkeysDisc).map((rec) => {
                    return {
                      key: rec.key,
                      id: rec.id,
                      sum: 0
                    };
                  });
                  let awbs = [];
                  //Map ULDs
                  if (inflight?.flight_uld.length > 0 && addtocalc) {
                    inflight?.flight_uld.map((uld) => {

                      if (uld?.flight_awbs.length > 0) {
                        uld?.flight_awbs.map((awb) => {
                          let found = false;
                          if (distinct_awbs.includes(awb?.awb_no)) {
                            found = true;
                          } else {
                            distinct_awbs.push(awb?.awb_no);
                          }
                          let awb_data = {
                            id: awb?.id,
                            awb_no: awb?.awb_no,
                            label: awb?.awb_no,
                            flight_count: '-',
                            awb_count: 0,
                            awb_count_disc: 0,
                            sum_awb_local: 0,
                            sum_awb_local_disc: 0,
                            sum_awb_export: 0,
                            sum_awb_export_disc: 0,
                            sum_awb_transit: 0,
                            sum_awb_transit_disc: 0,
                            sum_awb_bup: 0,
                            sum_awb_comat: 0,
                            sum_manifested: 0,
                          };
                          if (awb?.dest === this.station_code) {
                            sum_awb_local += parseFloat(awb?.wgt || 0);
                            sum_awb_local_disc += parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_local = parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_local_disc = parseFloat(awb?.wgt || 0);
                          } else if (awb?.org === this.station_code) {
                            sum_awb_export += parseFloat(awb?.wgt || 0);
                            sum_awb_export_disc += parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_export = parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_export_disc = parseFloat(awb?.wgt || 0);
                          } else if (awb?.org && awb?.dest) {
                            sum_awb_transit += parseFloat(awb?.wgt || 0);
                            sum_awb_transit_disc += parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_transit = parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_transit_disc = parseFloat(awb?.wgt || 0);
                          }
                          if (awb?.type === 'BUP') {
                            sum_awb_bup += parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_bup = parseFloat(awb?.wgt || 0);
                          } else if (awb?.type === 'COMAT') {
                            sum_awb_comat += parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_comat = parseFloat(awb?.wgt || 0);
                          }
                          if (awb) {
                            awb_count += found ? 0 : 1;
                            awb_count_disc += found ? 0 : 1;
                            awb_data.awb_count = found ? 0 : 1;
                            awb_data.awb_count_disc = found ? 0 : 1;

                            sum_manifested += parseFloat(awb?.wgt || 0);
                            awb_data.sum_manifested = parseFloat(awb?.wgt || 0);
                          }
                          sum_prodvals.map((rec) => {
                            // Check if awb.products contains a product with matching id
                            const hasProduct = Array.isArray(awb?.products) && awb.products.some(product => product.id === rec.id);
                            if (hasProduct) {
                              rec.sum += 1;
                              awb_data[rec.key] = 1;
                            } else {
                              awb_data[rec.key] = 0;
                            }
                          });
                          sum_prodvals_disc.map((rec) => {
                            // Check if awb.products contains a product with matching id
                            const hasProduct = Array.isArray(awb?.products) && awb.products.some(product => product.id === rec.id);
                            if (hasProduct) {
                              rec.sum += 1;
                              awb_data[rec.key] = 1;
                            } else {
                              awb_data[rec.key] = 0;
                            }
                          });
                          awbs.push(awb_data);
                          ib_awbs.push({ awb_no: awb?.awb_no });
                        });
                      }
                    });
                  }
                  if (flight_discrepancies.length > 0 && addtocalc) {
                    flight_discrepancies.map((rec) => {
                      let found = false;
                      if (distinct_awbs.includes(rec?.awb_no)) {
                        found = true;
                      } else {
                        distinct_awbs.push(rec?.awb_no);
                      }
                      if (rec?.type === 'Missing Cargo' || rec?.type === 'Short Shipped') {
                        let awb_data = {
                          id: rec?.id,
                          awb_no: rec?.awb_no,
                          label: <>{rec?.awb_no} &nbsp; <span className={fltLoadInfoStyles.discType}>{rec?.type}</span></>,
                          flight_count: '-',
                          awb_count_disc: 0,
                          sum_awb_local_disc: 0,
                          sum_awb_export_disc: 0,
                          sum_awb_transit_disc: 0,
                          sum_manifested: 0,
                          prod_code: rec?.prod_code,
                          products: rec?.products || [],
                        };
                        sum_prodvals_disc.map((rec1) => {
                          // Check if awb.products contains a product with matching id
                          const hasProduct = Array.isArray(awb_data?.products) && awb_data.products.some(product => product.id === rec1.id);
                          if (hasProduct) {
                            rec1.sum += 1;
                            awb_data[rec1.key] = 1;
                          } else {
                            awb_data[rec1.key] = 0;
                          }
                        });

                        if (rec?.dest === this.station_code) {
                          awb_data.awb_count_disc += found ? 0 : 1;
                          awb_count_disc += found ? 0 : 1;
                          awb_data.sum_awb_local_disc -= parseFloat(rec?.d_wgt);
                          sum_awb_local_disc -= parseFloat(rec?.d_wgt);
                        } else if (rec?.org === this.station_code) {
                          awb_data.awb_count_disc += found ? 0 : 1;
                          awb_count_disc += found ? 0 : 1;
                          awb_data.sum_awb_export_disc -= parseFloat(rec?.d_wgt);
                          sum_awb_export_disc -= parseFloat(rec?.d_wgt);
                        } else if (rec?.org && rec?.dest) {
                          awb_data.awb_count_disc += found ? 0 : 1;
                          awb_count_disc += found ? 0 : 1;
                          awb_data.sum_awb_transit_disc -= parseFloat(rec?.d_wgt);
                          sum_awb_transit_disc -= parseFloat(rec?.d_wgt);
                        }
                        awbs.push(awb_data);
                        ib_awbs.push({ awb_no: rec?.awb_no });
                      } else if (rec?.type === 'Found Cargo' || rec?.type === 'Over Carried') {
                        let awb_data = {
                          id: rec?.id,
                          awb_no: rec?.awb_no,
                          label: <>{rec?.awb_no} &nbsp; <span className={fltLoadInfoStyles.discType}>{rec?.type}</span></>,
                          flight_count: '-',
                          awb_count_disc: 0,
                          sum_awb_local_disc: 0,
                          sum_awb_export_disc: 0,
                          sum_awb_transit_disc: 0,
                          sum_manifested: 0,
                          prod_code: rec?.prod_code,
                          products: rec?.products || [],
                        };

                        sum_prodvals_disc.map((rec1) => {
                          // Check if awb.products contains a product with matching id
                          const hasProduct = Array.isArray(awb_data?.products) && awb_data.products.some(product => product.id === rec1.id);
                          if (hasProduct) {
                            rec1.sum += 1;
                            awb_data[rec1.key] = 1;
                          } else {
                            awb_data[rec1.key] = 0;
                          }
                        });
                        if (rec?.dest === this.station_code) {
                          awb_data.awb_count_disc += found ? 0 : 1;
                          awb_count_disc += found ? 0 : 1;
                          awb_data.sum_awb_local_disc += parseFloat(rec?.d_wgt);
                          sum_awb_local_disc += parseFloat(rec?.d_wgt);
                        } else if (rec?.org === this.station_code) {
                          awb_data.awb_count_disc += found ? 0 : 1;
                          awb_count_disc += found ? 0 : 1;
                          awb_data.sum_awb_export_disc += parseFloat(rec?.d_wgt);
                          sum_awb_export_disc += parseFloat(rec?.d_wgt);
                        } else if (rec?.org && rec?.dest) {
                          awb_data.awb_count_disc += found ? 0 : 1;
                          awb_count_disc += found ? 0 : 1;
                          awb_data.sum_awb_transit_disc += parseFloat(rec?.d_wgt);
                          sum_awb_transit_disc += parseFloat(rec?.d_wgt);
                        }
                        awbs.push(awb_data);
                        ib_awbs.push({ awb_no: rec?.awb_no });
                      }
                    });
                  }

                  let flight = {
                    id: inflight?.id,
                    airlineCode: getFlightAirlineCode(inflight, airline),
                    flight_no: inflight?.flight_no,
                    label: `${getFlightAirlineCode(inflight, airline)}${inflight?.flight_no}/${moment(inflight?.flight_date, 'YYYY-MM-DD').format('DDMMMYY')} (${inflight?.org}-${inflight?.dest})`,
                    act_arr: inflight?.act_arr,
                    act_dept: inflight?.act_dept,
                    schdl_arr: inflight?.schdl_arr,
                    schdl_dept: inflight?.schdl_dept,
                    org: inflight?.org,
                    dest: inflight?.dest,
                    url: `/flight_folder/notes?id=${inflight.id}`,
                    flight_schedule_id: inflight?.flight_schedule_id,
                    contractData: awbs,
                    transit_awbs: inflight?.transit_awbs || [],
                    flight_count: addtocalc ? 1 : 0,
                    awb_count: addtocalc ? awb_count : 0,
                    awb_count_disc: addtocalc ? awb_count_disc : 0,
                    sum_awb_local: addtocalc ? sum_awb_local : 0,
                    sum_awb_local_disc: addtocalc ? sum_awb_local_disc : 0,
                    sum_awb_export: addtocalc ? sum_awb_export : 0,
                    sum_awb_export_disc: addtocalc ? sum_awb_export_disc : 0,
                    sum_awb_transit: addtocalc ? sum_awb_transit : 0,
                    sum_awb_transit_disc: addtocalc ? sum_awb_transit_disc : 0,
                    sum_awb_bup: addtocalc ? sum_awb_bup : 0,
                    sum_awb_comat: addtocalc ? sum_awb_comat : 0,
                    sum_manifested: addtocalc ? sum_manifested : 0,
                    subRows: awbs,
                    reports: inflight?.reports || [],
                  };
                  sum_prodvals.map((rec) => {
                    flight[rec.key] = rec.sum;
                  });
                  sum_prodvals_disc.map((rec) => {
                    flight[rec.key] = rec.sum;
                  });

                  ib_awb_count += awb_count;
                  ib_awb_count_disc += awb_count_disc;
                  ib_sum_awb_local += sum_awb_local;
                  ib_sum_awb_local_disc += sum_awb_local_disc;
                  ib_sum_awb_export += sum_awb_export;
                  ib_sum_awb_export_disc += sum_awb_export_disc;
                  ib_sum_awb_transit += sum_awb_transit;
                  ib_sum_awb_transit_disc += sum_awb_transit_disc;
                  ib_sum_awb_bup += sum_awb_bup;
                  ib_sum_awb_comat += sum_awb_comat;
                  ib_sum_manifested += sum_manifested;
                  ib_prodvals.map((rec) => {
                    rec.sum += flight[rec.key];
                  });
                  ib_prodvals_disc.map((rec) => {
                    rec.sum += flight[rec.key];
                  });
                  inbound_data.push(flight);
                });
              }
              let inboundgroupedDataArr = inbound_data.reduce((acc, obj) => {
                let key = `${obj.airlineCode}${obj.flight_no}`;
                if (!acc[key]) {
                  acc[key] = [];
                }
                acc[key].push(obj);
                return acc;
              }, {});
              let inboundParent = [];  // Flight Num grouping
              if (Object.keys(inboundgroupedDataArr).length > 0) {
                Object.entries(inboundgroupedDataArr).map(([key, rec]) => {
                  let inboundParentObj = {
                    label: key,
                    flight_count: 0,
                    awb_count: 0,
                    awb_count_disc: 0,
                    sum_awb_local: 0,
                    sum_awb_local_disc: 0,
                    sum_awb_export: 0,
                    sum_awb_export_disc: 0,
                    sum_awb_transit: 0,
                    sum_awb_transit_disc: 0,
                    sum_awb_bup: 0,
                    sum_awb_comat: 0,
                    sum_manifested: 0,
                    subRows: rec,
                  };
                  if (rec && rec.length > 0) {
                    rec.map((rec) => {
                      inboundParentObj.flight_count += rec.flight_count;
                      inboundParentObj.awb_count += rec.awb_count;
                      inboundParentObj.awb_count_disc += rec.awb_count_disc;
                      inboundParentObj.sum_awb_local += rec.sum_awb_local;
                      inboundParentObj.sum_awb_local_disc += rec.sum_awb_local_disc;
                      inboundParentObj.sum_awb_export += rec.sum_awb_export;
                      inboundParentObj.sum_awb_export_disc += rec.sum_awb_export_disc;
                      inboundParentObj.sum_awb_transit += rec.sum_awb_transit;
                      inboundParentObj.sum_awb_transit_disc += rec.sum_awb_transit_disc;
                      inboundParentObj.sum_awb_bup += rec.sum_awb_bup;
                      inboundParentObj.sum_awb_comat += rec.sum_awb_comat;
                      inboundParentObj.sum_manifested += rec.sum_manifested;
                    });
                  }
                  inboundParent.push(inboundParentObj);
                });
              }
              inbound = {
                id: `${airline?.id}_inbound`,
                label: `${ib_flight_count} Inbound Flights`,
                ex_label: 'Import',
                flight_count: ib_flight_count,
                flights: inbound_data,
                contractData: inbound_data?.map(obj => obj.subRows).flat(),
                transit_awbs: [],
                awb_count: ib_awb_count,
                awb_count_disc: ib_awb_count_disc,
                sum_awb_local: ib_sum_awb_local,
                sum_awb_local_disc: ib_sum_awb_local_disc,
                sum_awb_export: ib_sum_awb_export,
                sum_awb_export_disc: ib_sum_awb_export_disc,
                sum_awb_transit: ib_sum_awb_transit,
                sum_awb_transit_disc: ib_sum_awb_transit_disc,
                sum_awb_bup: ib_sum_awb_bup,
                sum_awb_comat: ib_sum_awb_comat,
                sum_manifested: ib_sum_manifested,
                subRows: inboundParent,
                ib_awbs: ib_awbs,
              };
              ib_prodvals.map((rec) => {
                inbound[rec.key] = rec.sum;
              });
              ib_prodvals_disc.map((rec) => {
                inbound[rec.key] = rec.sum;
              });


              let ob_flight_count = 0;
              let ob_awb_count = 0;
              let ob_awb_count_disc = 0;
              let ob_sum_awb_local = 0;
              let ob_sum_awb_local_disc = 0;
              let ob_sum_awb_export = 0;
              let ob_sum_awb_export_disc = 0;
              let ob_sum_awb_transit = 0;
              let ob_sum_awb_transit_disc = 0;
              let ob_sum_awb_bup = 0;
              let ob_sum_awb_comat = 0;
              let ob_sum_manifested = 0;
              let ob_prodvals = cloneDeep(this.state.prodkeys).map((rec) => {
                return {
                  key: rec.key,
                  id: rec.id,
                  sum: 0
                };
              });
              let ob_prodvals_disc = cloneDeep(this.state.prodkeysDisc).map((rec) => {
                return {
                  key: rec.key,
                  id: rec.id,
                  sum: 0
                };
              });

              if (airline?.outbound?.length > 0) {
                ob_flight_count = airline?.outbound?.filter((outflight) => {
                  return outflight.status === 'Finalized' || outflight.status === 'Pending' || outflight.status === 'Approved';
                }).length;
                airline?.outbound.map((outflight) => {
                  console.log('outflight.status', outflight.status);
                  let addtocalc = false;
                  if (outflight.status === 'Finalized' || outflight.status === 'Pending' || outflight.status === 'Approved') {
                    addtocalc = true;
                  }
                  let flight_discrepancies = outflight?.flight_discrepancies;
                  let distinct_awbs = [];
                  let awb_count = 0;
                  let awb_count_disc = 0;
                  let sum_awb_local = 0;
                  let sum_awb_local_disc = 0;
                  let sum_awb_export = 0;
                  let sum_awb_export_disc = 0;
                  let sum_awb_transit = 0;
                  let sum_awb_transit_disc = 0;
                  let sum_awb_bup = 0;
                  let sum_awb_comat = 0;
                  let sum_manifested = 0;
                  let sum_prodvals = cloneDeep(this.state.prodkeys).map((rec) => {
                    return {
                      key: rec.key,
                      id: rec.id,
                      sum: 0
                    };
                  });
                  let sum_prodvals_disc = cloneDeep(this.state.prodkeysDisc).map((rec) => {
                    return {
                      key: rec.key,
                      id: rec.id,
                      sum: 0
                    };
                  });
                  let awbs = [];
                  //Map ULDs
                  if (outflight?.flight_uld.length > 0 && addtocalc) {
                    outflight?.flight_uld.map((uld) => {

                      if (uld?.flight_awbs.length > 0) {
                        uld?.flight_awbs.map((awb) => {
                          let found = false;
                          if (distinct_awbs.includes(awb?.awb_no)) {
                            found = true;
                          } else {
                            distinct_awbs.push(awb?.awb_no);
                          }
                          let awb_data = {
                            id: awb?.id,
                            awb_no: awb?.awb_no,
                            label: awb?.awb_no,
                            flight_count: '-',
                            awb_count: 0,
                            awb_count_disc: 0,
                            sum_awb_local: 0,
                            sum_awb_local_disc: 0,
                            sum_awb_export: 0,
                            sum_awb_export_disc: 0,
                            sum_awb_transit: 0,
                            sum_awb_transit_disc: 0,
                            sum_awb_bup: 0,
                            sum_awb_comat: 0,
                            sum_manifested: 0,
                          };
                          if (awb?.dest === this.station_code) {
                            sum_awb_local += parseFloat(awb?.wgt || 0);
                            sum_awb_local_disc += parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_local = parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_local_disc = parseFloat(awb?.wgt || 0);
                          } else if (awb?.org === this.station_code) {
                            sum_awb_export += parseFloat(awb?.wgt || 0);
                            sum_awb_export_disc += parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_export = parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_export_disc = parseFloat(awb?.wgt || 0);
                          } else if (awb?.org && awb?.dest) {
                            sum_awb_transit += parseFloat(awb?.wgt || 0);
                            sum_awb_transit_disc += parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_transit = parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_transit_disc = parseFloat(awb?.wgt || 0);
                          }
                          if (awb?.type === 'BUP') {
                            sum_awb_bup += parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_bup = parseFloat(awb?.wgt || 0);
                          } else if (awb?.type === 'COMAT') {
                            sum_awb_comat += parseFloat(awb?.wgt || 0);
                            awb_data.sum_awb_comat = parseFloat(awb?.wgt || 0);
                          }
                          if (awb) {
                            awb_count += found ? 0 : 1;
                            awb_count_disc += found ? 0 : 1;
                            awb_data.awb_count = found ? 1 : 0;
                            awb_data.awb_count_disc = found ? 1 : 0;
                            sum_manifested += parseFloat(awb?.wgt || 0);
                            awb_data.sum_manifested = parseFloat(awb?.wgt || 0);
                          }
                          sum_prodvals.map((rec) => {
                            if (awb?.product?.id === rec.id) {
                              rec.sum += 1;
                              awb_data[rec.key] = 1;
                            } else {
                              awb_data[rec.key] = 0;
                            }
                          });
                          sum_prodvals_disc.map((rec) => {
                            if (awb?.product?.id === rec.id) {
                              rec.sum += 1;
                              awb_data[rec.key] = 1;
                            } else {
                              awb_data[rec.key] = 0;
                            }
                          });
                          awbs.push(awb_data);
                          ob_awbs.push({ awb_no: awb?.awb_no });
                        });
                      }
                    });
                  }

                  if (flight_discrepancies.length > 0  && addtocalc) {
                    flight_discrepancies.map((rec) => {
                      let found = false;
                      if (distinct_awbs.includes(rec?.awb_no)) {
                        found = true;
                      } else {
                        distinct_awbs.push(rec?.awb_no);
                      }
                      if (rec?.type === 'Missing Cargo' || rec?.type === 'Short Shipped') {
                        let awb_data = {
                          id: rec?.id,
                          awb_no: rec?.awb_no,
                          label: `${rec?.awb_no} - ${rec?.type}`,
                          flight_count: '-',
                          sum_awb_local_disc: 0,
                          sum_awb_export_disc: 0,
                          sum_awb_transit_disc: 0,
                          sum_manifested: 0,
                          prod_code: rec?.prod_code,
                          products: rec?.products || [],
                        };
                        sum_prodvals_disc.map((rec1) => {
                          // Check if awb.products contains a product with matching id
                          const hasProduct = Array.isArray(awb_data?.products) && awb_data.products.some(product => product.id === rec1.id);
                          if (hasProduct) {
                            rec1.sum += 1;
                            awb_data[rec1.key] = 1;
                          } else {
                            awb_data[rec1.key] = 0;
                          }
                        });
                        if (rec?.dest === this.station_code) {
                          awb_data.awb_count_disc += found ? 1 : 0;
                          awb_count_disc += found ? 1 : 0;
                          awb_data.sum_awb_local_disc -= parseFloat(rec?.d_wgt);
                          sum_awb_local_disc -= parseFloat(rec?.d_wgt);
                        } else if (rec?.org === this.station_code) {
                          awb_data.awb_count_disc += found ? 1 : 0;
                          awb_count_disc += found ? 1 : 0;
                          awb_data.sum_awb_export_disc -= parseFloat(rec?.d_wgt);
                          sum_awb_export_disc -= parseFloat(rec?.d_wgt);
                        } else if (rec?.org && rec?.dest) {
                          awb_data.awb_count_disc += found ? 1 : 0;
                          awb_count_disc += found ? 1 : 0;
                          awb_data.sum_awb_transit_disc -= parseFloat(rec?.d_wgt);
                          sum_awb_transit_disc -= parseFloat(rec?.d_wgt);
                        }
                        awbs.push(awb_data);
                        ob_awbs.push({ awb_no: rec?.awb_no });
                      } else if (rec?.type === 'Found Cargo' || rec?.type === 'Over Carried') {
                        let awb_data = {
                          id: rec?.id,
                          awb_no: rec?.awb_no,
                          label: `${rec?.awb_no} - ${rec?.type}`,
                          flight_count: '-',
                          awb_count_disc: 0,
                          sum_awb_local_disc: 0,
                          sum_awb_export_disc: 0,
                          sum_awb_transit_disc: 0,
                          sum_manifested: 0,
                          prod_code: rec?.prod_code,
                          products: rec?.products || [],
                        };
                        sum_prodvals_disc.map((rec1) => {
                          // Check if the product exists in the AWB data
                          const hasProduct = Array.isArray(awb_data?.products) && awb_data.products.some(product => product.id === rec1.id);
                          if (hasProduct) {
                            rec1.sum += 1;
                            awb_data[rec1.key] = 1;
                          } else {
                            awb_data[rec1.key] = 0;
                          }
                        });
                        if (rec?.dest === this.station_code) {
                          awb_data.awb_count_disc += found ? 1 : 0;
                          awb_count_disc += found ? 1 : 0;
                          awb_data.sum_awb_local_disc += parseFloat(rec?.d_wgt);
                          sum_awb_local_disc += parseFloat(rec?.d_wgt);
                        } else if (rec?.org === this.station_code) {
                          awb_data.awb_count_disc += found ? 1 : 0;
                          awb_count_disc += found ? 1 : 0;
                          awb_data.sum_awb_export_disc += parseFloat(rec?.d_wgt);
                          sum_awb_export_disc += parseFloat(rec?.d_wgt);
                        } else if (rec?.org && rec?.dest) {
                          awb_data.awb_count_disc += found ? 1 : 0;
                          awb_count_disc += found ? 1 : 0;
                          awb_data.sum_awb_transit_disc += parseFloat(rec?.d_wgt);
                          sum_awb_transit_disc += parseFloat(rec?.d_wgt);
                        }
                        awbs.push(awb_data);
                        ob_awbs.push({ awb_no: rec?.awb_no });
                      }
                    });
                  }

                  let flight = {
                    id: outflight?.id,
                    airlineCode: getFlightAirlineCode(outflight, airline),
                    label: `${getFlightAirlineCode(outflight, airline)}${outflight?.flight_no}/${moment(outflight?.flight_date, 'YYYY-MM-DD').format('DDMMMYY')} (${outflight?.org}-${outflight?.dest})`,
                    act_arr: outflight?.act_arr,
                    act_dept: outflight?.act_dept,
                    schdl_arr: outflight?.schdl_arr,
                    schdl_dept: outflight?.schdl_dept,
                    org: outflight?.org,
                    dest: outflight?.dest,
                    url: `/flight_folder/notes?id=${outflight.id}`,
                    flight_schedule_id: outflight?.flight_schedule_id,
                    contractData: awbs,
                    transit_awbs: outflight?.transit_awbs || [],
                    flight_no: outflight?.flight_no,
                    flight_count: addtocalc ? 1 : 0,
                    awb_count: addtocalc ? awb_count : 0,
                    awb_count_disc: addtocalc ? awb_count_disc : 0,
                    sum_awb_local: addtocalc ? sum_awb_local : 0,
                    sum_awb_local_disc: addtocalc ? sum_awb_local_disc : 0,
                    sum_awb_export: addtocalc ? sum_awb_export : 0,
                    sum_awb_export_disc: addtocalc ? sum_awb_export_disc : 0,
                    sum_awb_transit: addtocalc ? sum_awb_transit : 0,
                    sum_awb_transit_disc: addtocalc ? sum_awb_transit_disc : 0,
                    sum_awb_bup: addtocalc ? sum_awb_bup : 0,
                    sum_awb_comat: addtocalc ? sum_awb_comat : 0,
                    sum_manifested: addtocalc ? sum_manifested : 0,
                    subRows: awbs,
                    reports: outflight?.reports || [],
                  };
                  sum_prodvals.map((rec) => {
                    flight[rec.key] = rec.sum;
                  });
                  sum_prodvals_disc.map((rec) => {
                    flight[rec.key] = rec.sum;
                  });

                  ob_awb_count += awb_count;
                  ob_awb_count_disc += awb_count_disc;
                  ob_sum_awb_local += sum_awb_local;
                  ob_sum_awb_local_disc += sum_awb_local_disc;
                  ob_sum_awb_export += sum_awb_export;
                  ob_sum_awb_export_disc += sum_awb_export_disc;
                  ob_sum_awb_transit += sum_awb_transit;
                  ob_sum_awb_transit_disc += sum_awb_transit_disc;
                  ob_sum_awb_bup += sum_awb_bup;
                  ob_sum_awb_comat += sum_awb_comat;
                  ob_sum_manifested += sum_manifested;
                  ob_prodvals.map((rec) => {
                    rec.sum += flight[rec.key];
                  });
                  ob_prodvals_disc.map((rec) => {
                    rec.sum += flight[rec.key];
                  });
                  outbound_data.push(flight);

                });
              }
              let outboundgroupedDataArr = outbound_data.reduce((acc, obj) => {
                let key = `${obj.airlineCode}${obj.flight_no}`;
                if (!acc[key]) {
                  acc[key] = [];
                }
                acc[key].push(obj);
                return acc;
              }, {});
              let outboundParent = [];  // Flight Num grouping
              if (Object.keys(outboundgroupedDataArr).length > 0) {
                Object.entries(outboundgroupedDataArr).map(([key, rec]) => {
                  let outboundParentObj = {
                    label: key,
                    flight_count: 0,
                    awb_count: 0,
                    awb_count_disc: 0,
                    sum_awb_local: 0,
                    sum_awb_local_disc: 0,
                    sum_awb_export: 0,
                    sum_awb_export_disc: 0,
                    sum_awb_transit: 0,
                    sum_awb_transit_disc: 0,
                    sum_awb_bup: 0,
                    sum_awb_comat: 0,
                    sum_manifested: 0,
                    subRows: rec,
                  };
                  if (rec && rec.length > 0) {
                    rec.map((rec) => {
                      outboundParentObj.flight_count += rec.flight_count;
                      outboundParentObj.awb_count += rec.awb_count;
                      outboundParentObj.awb_count_disc += rec.awb_count_disc;
                      outboundParentObj.sum_awb_local += rec.sum_awb_local;
                      outboundParentObj.sum_awb_local_disc += rec.sum_awb_local_disc;
                      outboundParentObj.sum_awb_export += rec.sum_awb_export;
                      outboundParentObj.sum_awb_export_disc += rec.sum_awb_export_disc;
                      outboundParentObj.sum_awb_transit += rec.sum_awb_transit;
                      outboundParentObj.sum_awb_transit_disc += rec.sum_awb_transit_disc;
                      outboundParentObj.sum_awb_bup += rec.sum_awb_bup;
                      outboundParentObj.sum_awb_comat += rec.sum_awb_comat;
                      outboundParentObj.sum_manifested += rec.sum_manifested;
                    });
                  }
                  outboundParent.push(outboundParentObj);
                });
              }
              outbound = {
                id: `${airline?.id}_outbound`,
                label: `${ob_flight_count} Outbound Flights`,
                ex_label: 'Export',
                flight_count: ob_flight_count,
                flights: outbound_data,
                contractData: outbound_data?.map(obj => obj.subRows).flat(),
                transit_awbs:[],
                awb_count: ob_awb_count,
                awb_count_disc: ob_awb_count_disc,
                sum_awb_local: ob_sum_awb_local,
                sum_awb_local_disc: ob_sum_awb_local_disc,
                sum_awb_export: ob_sum_awb_export,
                sum_awb_export_disc: ob_sum_awb_export_disc,
                sum_awb_transit: ob_sum_awb_transit,
                sum_awb_transit_disc: ob_sum_awb_transit_disc,
                sum_awb_bup: ob_sum_awb_bup,
                sum_awb_comat: ob_sum_awb_comat,
                sum_manifested: ob_sum_manifested,
                subRows: outboundParent,
                ob_awbs: ob_awbs,
              };
              ob_prodvals.map((rec) => {
                outbound[rec.key] = rec.sum;
              });
              ob_prodvals_disc.map((rec) => {
                outbound[rec.key] = rec.sum;
              });

              // let mainParent = [];  // Flight Num grouping
              let airline_data = {
                id: airline?.id,
                label: `${parseInt(ib_flight_count) + parseInt(ob_flight_count)} ${airline?.code} Flights`,
                ex_label: airline?.code,
                flight_count: ib_flight_count + ob_flight_count,
                inbound: inbound,
                outbound: outbound,
                contractData: [
                  ...inbound.contractData,
                  ...outbound.contractData
                ],
                transit_awbs: [],
                awb_count: ib_awb_count + ob_awb_count,
                awb_count_disc: ib_awb_count_disc + ob_awb_count_disc,
                sum_awb_local: ib_sum_awb_local + ob_sum_awb_local,
                sum_awb_local_disc: ib_sum_awb_local_disc + ob_sum_awb_local_disc,
                sum_awb_export: ib_sum_awb_export + ob_sum_awb_export,
                sum_awb_export_disc: ib_sum_awb_export_disc + ob_sum_awb_export_disc,
                sum_awb_transit: ib_sum_awb_transit + ob_sum_awb_transit,
                sum_awb_transit_disc: ib_sum_awb_transit_disc + ob_sum_awb_transit_disc,
                sum_awb_bup: ib_sum_awb_bup + ob_sum_awb_bup,
                sum_awb_comat: ib_sum_awb_comat + ob_sum_awb_comat,
                sum_manifested: ib_sum_manifested + ob_sum_manifested,
                subRows: [inbound, outbound],
              };
              ib_prodvals.map((rec, index) => {
                airline_data[rec.key] = ib_prodvals[index].sum + ob_prodvals[index].sum;
              });
              ib_prodvals_disc.map((rec, index) => {
                airline_data[rec.key] = ib_prodvals_disc[index].sum + ob_prodvals_disc[index].sum;
              });
              billingData.push(airline_data);
              // mainParent.push(airline_data);
              // mainParent.inbound = inboundParent;
              // mainParent.outbound = outboundParent;
              // this.setSummary(mainParent, 'airline');
            });
            // let summaryData = billingData;
            this.setState({ billingData: billingData }, () => {
              if(!callType || callType !== 'excel'){
                this.filter();
                this.setSummary(this.state.billingData, 'airline');
              }
              if (this.state.billingFields.transit === 'inbound' || this.state.billingFields.transit === 'outbound') {
                this.filterData();
                if (callback) return callback(true);
              } else {
                if (callback) {
                  this.filterData();
                  return callback(true);
                }
              }
            });
          } else {
            this.setState({ billingData: [] });
            return callback(true);
          }
        });
    }
  };

  filterData = () => {
    const subtractValues = (obj, awb, fields) => {
      fields.forEach(field => {
        obj[field] = parseFloat(obj[field]) - (parseFloat(awb[field]) || 0);
      });
    };

    // const fields = ['sum_awb_local', 'sum_awb_local_disc', 'sum_awb_transit', 'sum_awb_transit_disc', 'sum_awb_bup', 'sum_awb_comat', 'sum_manifested'];
    const fields = [/*'sum_awb_local', 'sum_awb_local_disc',*/ 'sum_awb_transit', 'sum_awb_transit_disc', /*'sum_awb_bup', 'sum_awb_comat', 'sum_manifested'*/];
    let filteredData = cloneDeep(this.state.contractData);

    for (let airline of filteredData) {
      if (airline?.subRows?.length > 0) {
        let inbound = airline?.subRows.find((row) => row.label === 'Inbound');
        let outbound = airline?.subRows.find((row) => row.label === 'Outbound');
        let ib_awbs = inbound?.ib_awbs || [];
        let ob_awbs = outbound?.ob_awbs || [];

        switch (this.state.billingFields.transit) {
          case 'inbound':
            if (ib_awbs.length > 0) {
              for (let flightParent of outbound?.subRows || []) {
                for (let flight of flightParent?.subRows || []) {
                  let awbs = [];
                  for (let awb of flight?.subRows || []) {
                    let awb_index = ib_awbs.findIndex((rec) => rec.awb_no === awb.awb_no);
                    if (awb_index > -1) {
                      subtractValues(flight, awb, fields);
                      subtractValues(flightParent, awb, fields);
                      subtractValues(outbound, awb, fields);
                      subtractValues(airline, awb, fields);
                      awbs.push(awb);
                    } else {
                      awbs.push(awb);
                    }
                  }
                  flight.subRows = awbs;
                }
              }
            }
            break;
          case 'outbound':
            if (ob_awbs.length > 0) {
              for (let flightParent of inbound?.subRows || []) {
                for (let flight of flightParent?.subRows || []) {
                  let awbs = [];
                  for (let awb of flight?.subRows || []) {
                    let awb_index = ob_awbs.findIndex((rec) => rec.awb_no === awb.awb_no);
                    if (awb_index > -1) {
                      subtractValues(flight, awb, fields);
                      subtractValues(flightParent, awb, fields);
                      subtractValues(inbound, awb, fields);
                      subtractValues(airline, awb, fields);
                      awbs.push(awb);
                    } else {
                      awbs.push(awb);
                    }
                  }
                  flight.subRows = awbs;
                }
              }
            }
            break;
          default:
            break;
        }
        airline.subRows = [inbound, outbound];
      }
    }
    this.setState({ filteredData: filteredData });
  };

  // generateBillingReport = () => {
  //   if (this.state.searchFields.month && this.state.searchFields.airline) {
  //     http.get(`/generate_billing?month=${this.state.searchFields.month}&station=${this.station_code}&airline=${this.state.searchFields.airline}`)
  //       .then(({ data }) => {
  //         console.log('data', data);
  //       });
  //   }
  // };

  generateBillingColumns = (callType, type, callback) => {
    function formatNumber(num) {
      return num % 1 === 0 ? Math.round(num) : num.toFixed(2);
    }
    let prodkeys = [];
    let prodkeysDisc = [];
    let columns = [];
    if (this.state.billingFields.exclude_disc) {
      columns.push(
        {
          field: 'awb_count',
          headerName: 'AWBS',
          className: styles.rowLabels,
          width: 200,
          flex: 1,
          renderCell: (data) => {
            return (
              <div>
                {data.row.label}
              </div>
            );
          },
        },
        {
          field: 'sum_awb_local',
          headerName: 'AWBS local (KG)',
          width: 200,
          flex: 1,
          renderCell: ({ row }) => {
            let value = typeof row.sum_awb_local === 'number' ? formatNumber(Math.round(row.sum_awb_local * 100) / 100) : row.sum_awb_local;
            return value === 0 ? 'Nil' : value;
          },
        },
        {
          field: 'sum_awb_transit',
          headerName: 'AWBS transit (KG)',
          width: 200,
          flex: 1,
          renderCell: ({ row }) => {
            let value = typeof row.sum_awb_transit === 'number' ? formatNumber(Math.round(row.sum_awb_transit * 100) / 100) : row.sum_awb_transit;
            return value === 0 ? 'Nil' : value;
          },
        },
        {
          field: 'sum_awb_export',
          headerName: 'AWBS export (KG)',
          width: 200,
          flex: 1,
          renderCell: ({ row }) => {
            let value = typeof row.sum_awb_export === 'number' ? formatNumber(Math.round(row.sum_awb_export * 100) / 100) : row.sum_awb_export;
            return value === 0 ? 'Nil' : value;
          }
        },
      );
    } else {
      columns.push(
        {
          field: 'awb_count_disc',
          headerName: 'AWBS',
          className: styles.rowLabels,
          width: 200,
          flex: 1,
          renderCell: (data) => {
            return (
              <div>
                {data.row.label}
              </div>
            );
          },
        },
        {
          field: 'sum_awb_local_disc',
          headerName: 'AWBS local (KG)',
          width: 200,
          flex: 1,
          renderCell: ({ row }) => {
            let value = typeof row.sum_awb_local_disc === 'number' ? formatNumber(Math.round(row.sum_awb_local_disc * 100) / 100) : row.sum_awb_local_disc;
            value = value < 0 ? value * -1 : value;
            return value === 0 ? 'Nil' : value;
          },
        },
        {
          field: 'sum_awb_transit_disc',
          headerName: 'AWBS transit (KG)',
          width: 200,
          flex: 1,
          renderCell: ({ row }) => {
            let value = typeof row.sum_awb_transit_disc === 'number' ? formatNumber(Math.round(row.sum_awb_transit_disc * 100) / 100) : row.sum_awb_transit_disc;
            value = value < 0 ? value * -1 : value;
            return value === 0 ? 'Nil' : value;
          },
        },
        {
          field: 'sum_awb_export_disc',
          headerName: 'AWBS export (KG)',
          width: 200,
          flex: 1,
          renderCell: ({ row }) => {
            let value = typeof row.sum_awb_export_disc === 'number' ? formatNumber(Math.round(row.sum_awb_export_disc * 100) / 100) : row.sum_awb_export_disc;
            value = value < 0 ? value * -1 : value;
            return value === 0 ? 'Nil' : value;
          }
        },
      );
    }
    columns.push(
      {
        field: 'sum_manifested',
        headerName: 'TOTAL CARGO manifested (KG)',
        width: 200,
        flex: 1,
        renderCell: ({ row }) => {
          let value = typeof row.sum_manifested === 'number' ? formatNumber(Math.round(row.sum_manifested * 100) / 100) : row.sum_manifested;
          value = value < 0 ? value * -1 : value;
          return value === 0 ? 'Nil' : value;
        },
      },
    );
    if (this.state.products && this.state.products.length > 0) {
      columns.push(
        {
          field: 'product',
          headerName: 'Product',
          width: 200,
          flex: 1,
          // renderCell: ({ row }) => {
          //   let a = this.state.products.map((product) => {
          //     let prod = row[`sum_${product.name.trim()?.toLowerCase()}`];
          //     return prod && prod !== 0 ? `${product.name} (${prod})` : row.prod_code;
          //   });
          //   let prod_code = a && a.filter((item, index, inputArray) => {
          //     return inputArray.indexOf(item) == index;
          //   });
          //   let hasNullElements = a && a.every((item) => item == null || item == undefined);
          //   return hasNullElements ? '-' : prod_code;
          // },
          renderCell: ({ row }) => {
            // Only include products with a non-zero count
            let productList = this.state.products
              .map(product => {
                let count = row[`sum_${product.name.trim()?.toLowerCase()}`];
                return count && count !== 0 ? `${product.name} (${count})` : null;
              })
              .filter(Boolean); // Remove nulls

            return productList.length > 0 ? productList.join(', ') : '-';
          },
        },
      );
      this.state.products.map((product) => {
        if (this.state.billingFields.exclude_disc) {
          columns.push({
            field: `sum_${product.name?.trim()?.toLowerCase()}`,
            headerName: `# of ${product.name}`,
            width: 200,
            flex: 1,
          });
        }
        else {
          columns.push({
            field: `sum_${product.name?.trim()?.toLowerCase()}_disc`,
            headerName: `# of ${product.name}`,
            width: 200,
            flex: 1,
          });
        }
        prodkeys.push(
          {
            key: `sum_${product.name?.trim()?.toLowerCase()}`,
            id: product.id
          }
        );
        prodkeysDisc.push(
          {
            key: `sum_${product.name?.trim()?.toLowerCase()}_disc`,
            id: product.id
          }
        );
      });
    }
    //array without products
    let cloneColumn = cloneDeep(columns);
    let columLength = cloneColumn.length;
    let prodLength = this.state?.products?.length || 0;
    let total = columLength - prodLength;
    cloneColumn.splice(total, prodLength);

    //array without products column
    let billingColumns = cloneDeep(columns);
    let productIndex = billingColumns.findIndex((item) => item.field === 'product');
    if (productIndex !== -1) {
      billingColumns.splice(productIndex, 1);
    }

    this.setState({
      billingCol: cloneColumn,
      billingColumns: billingColumns,
      prodkeys: prodkeys,
      prodkeysDisc: prodkeysDisc,
    }, () => {
      if (type === 'fetch') {
        this.fetchBillingReport( callType, () => {
          if (callback) return callback(true);
        }
        );
      } else {
        if (callback) return callback(true);
      }
    });
  };

  triggerNewBilling = (regenerate = false,) => {
    let from = moment(this.state.searchFields.from).format('YYYY-MM-DD');
    let to = moment(this.state.searchFields.to).format('YYYY-MM-DD');
    if (this.state.searchFields.month) {
      if (this.state.searchFields.period === 'month') {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
      } else if (this.state.searchFields.period === 'first') {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').add(14, 'days').format('YYYY-MM-DD');
      } else {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').add(15, 'days').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
      }
    }
    if (this.state.searchFields.airline) {
      http.get(`/populate_billing_queues?from=${from}&to=${to}&station=${this.station_code}&airline=${this.state.searchFields.airline}&type=${this.state.cont_item}&regenerate=${regenerate}`)  
        .then(({ data }) => {
          if(data?.data.length > 2){
            toast.success(data?.message);
          } else {
            toast.warning(data?.message);
          }
        });
    }
  };
  triggerNewNewBilling = (regenerate = false,) => {
    let from = moment(this.state.searchFields.from).format('YYYY-MM-DD');
    let to = moment(this.state.searchFields.to).format('YYYY-MM-DD');
    if (this.state.searchFields.month) {
      if (this.state.searchFields.period === 'month') {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
      } else if (this.state.searchFields.period === 'first') {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').add(14, 'days').format('YYYY-MM-DD');
      } else {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').add(15, 'days').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
      }
    }
    console.log('this.state.searchFields.airline', this.state.searchFields.airline);
    let combinationId = null;
    if(typeof this.state.searchFields.airline === 'string'){
      const searchAirline = this.state.searchFields.airline.split(',').sort((a, b) => Number(a) - Number(b)).join(',');
      combinationId = this.state.combinationAirline.find((row) => {const airlineIds = row.airlines.map((airline) => airline.id.toString()).sort((a, b) => Number(a) - Number(b)).join(',');return airlineIds === searchAirline;});
    }
    console.log('combinationId_________________________________', combinationId);
    if (this.state.searchFields.airline) {
      http.get(`/populate_billing_queues_new?from=${from}&to=${to}&station=${this.station_code}&airline=${this.state.searchFields.airline}&combinationid=${combinationId?.id || null}&type=${this.state.cont_item}&regenerate=${regenerate}`)
        .then(({ data }) => {
          if(data?.data.length > 2){
            toast.success(data?.message);
          } else {
            toast.warning(data?.message);
          }
        });
    }
  };
  fetchInvoiceData = (regenerate = false, callType = null, callback = false) => {
    // dont proceed if billingExists is false
    if (!this.state.billingExists) {
      return;
    }
    this.setState({ genInvProgress: true });
    let from = moment(this.state.searchFields.from).format('YYYY-MM-DD');
    let to = moment(this.state.searchFields.to).format('YYYY-MM-DD');
    if (this.state.searchFields.month) {
      if (this.state.searchFields.period === 'month') {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
      } else if (this.state.searchFields.period === 'first') {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').add(14, 'days').format('YYYY-MM-DD');
      } else {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').add(15, 'days').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
      }
    }
    let dateType = 'actual';
    if(this.state.billingFields.dateType === 'scheduled'){
      dateType = 'scheduled';
    }
    if (this.state.manifestDate) {
      dateType = 'manifest_date';
    }
    console.log('this.state.combinationAirline#################################', this.state.combinationAirline);
    console.log('this.state.searchFields.airline', this.state.searchFields.airline);
    if (this.state.searchFields.airline) {
      let combinationId = null;
      if(typeof this.state.searchFields.airline === 'string'){
        combinationId = this.state.combinationAirline.find((row) => row.airlines.map((airline) => airline.id.toString()).sort().join(',') === this.state.searchFields.airline);
      }
      console.log('combinationId_________________________________', combinationId);
      http.get(`/generate_invoice?from=${from}&to=${to}&station=${this.station_code}&airline=${this.state.searchFields.airline}&combinationid=${combinationId?.id || null}&type=${this.state.cont_item}&regenerate=${regenerate}&datetype=${dateType}`)
        .then(({ data }) => {
          // sort airlinecontracts, daycontracts, inflightcontracts, monthcontracts, outflightcontracts by position
          if(data.data.airlinecontracts[0]?.contractData)
            data.data.airlinecontracts[0].contractData = data.data.airlinecontracts?.[0]?.contractData.sort((a, b) => a.position - b.position);
          if(data.data.daycontracts[0]?.contractData)
            data.data.daycontracts[0].contractData = data.data.daycontracts?.[0]?.contractData.sort((a, b) => a.position - b.position);
          if(data.data.inflightcontracts[0]?.contractData)
            data.data.inflightcontracts[0].contractData = data.data.inflightcontracts?.[0]?.contractData.sort((a, b) => a.position - b.position);
          if(data.data.monthcontracts[0]?.contractData)
            data.data.monthcontracts[0].contractData = data.data.monthcontracts?.[0]?.contractData.sort((a, b) => a.position - b.position);
          if(data.data.outflightcontracts[0]?.contractData)
            data.data.outflightcontracts[0].contractData = data.data.outflightcontracts?.[0]?.contractData.sort((a, b) => a.position - b.position);
          let customReportOptions = [];
          if(data.data?.airlinecontracts.length > 0 && data.data?.airlinecontracts[0]?.contractData){
            data.data?.airlinecontracts[0]?.contractData.map((item) => {
              console.log('item', item);
              customReportOptions.push({
                title: item.label,
                value: item.id,
              });
            });
            // customReportOptions = data.data?.airlinecontracts[0]?.contractData;
            //also add noncommercialData
          }
          if(data.data?.airlinecontracts[0]?.noncommercialData){
            data.data?.airlinecontracts[0]?.noncommercialData.map((item) => {
              customReportOptions.push({
                title: item.description,
                value: item.id,
              });
            });
            // customReportOptions = customReportOptions.concat(data.data?.airlinecontracts[0]?.noncommercialData);
          }
          // generate_invoice
          let flightdata = [];
          let invoicedata = data.data;
          let billingData = [];
          let csvContracts = [];
          if(data.data?.airlinecontracts.length > 0 && data.data?.airlinecontracts[0]?.noncommercialData.length > 0){
            csvContracts = data.data?.airlinecontracts[0]?.noncommercialData;
          }
          let alcontractsData = [];
          let invoice_info = data.data.invoice_infos[0] || null;
          //getinboundContractData
          let inbound_contractData = [];
          let inboundStatistics = {
            total_count: 0,
            finalized_count: 0,
            pending_count: 0,
            rejected_count: 0,
            approved_acc_count: 0,
            approved_air_count: 0
          };
          data.data.inflightcontracts.map((item, i) => {
            data.data.inflightcontracts[i].contractData = data.data.inflightcontracts[i].contractData.map((item, index) => ({
              ...cloneDeep(item),
              id: `${index + 1}_inflight`,
              row_id: item.id,
              item: item.label,
              driver: item.applied_on?.split('|')[0].trim(),
              source: item.applied_on?.split('|')[1].trim(),
              position: item.position,
            }));
            item.contractData.map((rec) => {
              let ind = inbound_contractData.findIndex((obj) => obj.contractId === rec.contractId && obj.cont_rowId === rec.cont_rowId);
              if (ind === -1) {
                inbound_contractData.push(cloneDeep(rec));
              }
              else {
                inbound_contractData[ind].quantity = (!isNaN(inbound_contractData[ind].quantity) ? parseFloat(inbound_contractData[ind].quantity) : 0) + parseFloat(rec.quantity) || 0;
                inbound_contractData[ind].totalrate = (!isNaN(inbound_contractData[ind].totalrate) ? parseFloat(inbound_contractData[ind].totalrate) : 0) + parseFloat(rec.totalrate) || 0;
                inbound_contractData[ind].dis_quantity = (!isNaN(inbound_contractData[ind].dis_quantity) ? parseFloat(inbound_contractData[ind].dis_quantity) : 0) + parseFloat(rec.dis_quantity) || 0;
                inbound_contractData[ind].dis_totalrate = (!isNaN(inbound_contractData[ind].dis_totalrate) ? parseFloat(inbound_contractData[ind].dis_totalrate) : 0) + parseFloat(rec.dis_totalrate) || 0;
                inbound_contractData[ind].in_quantity = (!isNaN(inbound_contractData[ind].in_quantity) ? parseFloat(inbound_contractData[ind].in_quantity) : 0) + parseFloat(rec.in_quantity) || 0;
                inbound_contractData[ind].in_totalrate = (!isNaN(inbound_contractData[ind].in_totalrate) ? parseFloat(inbound_contractData[ind].in_totalrate) : 0) + parseFloat(rec.in_totalrate) || 0;
                inbound_contractData[ind].out_quantity = (!isNaN(inbound_contractData[ind].out_quantity) ? parseFloat(inbound_contractData[ind].out_quantity) : 0) + parseFloat(rec.out_quantity) || 0;
                inbound_contractData[ind].out_totalrate = (!isNaN(inbound_contractData[ind].out_totalrate) ? parseFloat(inbound_contractData[ind].out_totalrate) : 0) + parseFloat(rec.out_totalrate) || 0;
                inbound_contractData[ind].dis_in_quantity = (!isNaN(inbound_contractData[ind].dis_in_quantity) ? parseFloat(inbound_contractData[ind].dis_in_quantity) : 0) + parseFloat(rec.dis_in_quantity) || 0;
                inbound_contractData[ind].dis_in_totalrate = (!isNaN(inbound_contractData[ind].dis_in_totalrate) ? parseFloat(inbound_contractData[ind].dis_in_totalrate) : 0) + parseFloat(rec.dis_in_totalrate) || 0;
                inbound_contractData[ind].dis_out_quantity = (!isNaN(inbound_contractData[ind].dis_out_quantity) ? parseFloat(inbound_contractData[ind].dis_out_quantity) : 0) + parseFloat(rec.dis_out_quantity) || 0;
                inbound_contractData[ind].dis_out_totalrate = (!isNaN(inbound_contractData[ind].dis_out_totalrate) ? parseFloat(inbound_contractData[ind].dis_out_totalrate) : 0) + parseFloat(rec.dis_out_totalrate) || 0;

                inbound_contractData[ind].in_fquantity = (!isNaN(inbound_contractData[ind].in_fquantity) ? parseFloat(inbound_contractData[ind].in_fquantity) : 0) + parseFloat(rec.in_fquantity) || 0;
                inbound_contractData[ind].out_fquantity = (!isNaN(inbound_contractData[ind].out_fquantity) ? parseFloat(inbound_contractData[ind].out_fquantity) : 0) + parseFloat(rec.out_fquantity) || 0;
                inbound_contractData[ind].dis_in_fquantity = (!isNaN(inbound_contractData[ind].dis_in_fquantity) ? parseFloat(inbound_contractData[ind].dis_in_fquantity) : 0) + parseFloat(rec.dis_in_fquantity) || 0;
                inbound_contractData[ind].dis_out_fquantity = (!isNaN(inbound_contractData[ind].dis_out_fquantity) ? parseFloat(inbound_contractData[ind].dis_out_fquantity) : 0) + parseFloat(rec.dis_out_fquantity) || 0;
                inbound_contractData[ind].in_tquantity = (!isNaN(inbound_contractData[ind].in_tquantity) ? parseFloat(inbound_contractData[ind].in_tquantity) : 0) + parseFloat(rec.in_tquantity) || 0;
                inbound_contractData[ind].out_tquantity = (!isNaN(inbound_contractData[ind].out_tquantity) ? parseFloat(inbound_contractData[ind].out_tquantity) : 0) + parseFloat(rec.out_tquantity) || 0;
                inbound_contractData[ind].dis_in_tquantity = (!isNaN(inbound_contractData[ind].dis_in_tquantity) ? parseFloat(inbound_contractData[ind].dis_in_tquantity) : 0) + parseFloat(rec.dis_in_tquantity) || 0;
                inbound_contractData[ind].dis_out_tquantity = (!isNaN(inbound_contractData[ind].dis_out_tquantity) ? parseFloat(inbound_contractData[ind].dis_out_tquantity) : 0) + parseFloat(rec.dis_out_tquantity) || 0;
                
                // Initialize all quantities of inbound_contractData[ind].children to 0
                if (!inbound_contractData[ind].children || inbound_contractData[ind].children.length === 0) {
                  inbound_contractData[ind].children = rec.children ? rec.children.map(child => ({
                    ...child,
                    quantity: 0,
                    dis_quantity: 0,
                    in_quantity: 0,
                    out_quantity: 0,
                    dis_in_quantity: 0,
                    dis_out_quantity: 0,

                    in_fquantity: 0,
                    out_fquantity: 0,
                    dis_in_fquantity: 0,
                    dis_out_fquantity: 0,
                    in_tquantity: 0,
                    out_tquantity: 0,
                    dis_in_tquantity: 0,
                    dis_out_tquantity: 0,
                  })): [
                    {
                      quantity: 0,
                      dis_quantity: 0,
                      in_quantity: 0,
                      out_quantity: 0,
                      dis_in_quantity: 0,
                      dis_out_quantity: 0,

                      in_fquantity: 0,
                      out_fquantity: 0,
                      dis_in_fquantity: 0,
                      dis_out_fquantity: 0,
                      in_tquantity: 0,
                      out_tquantity: 0,
                      dis_in_tquantity: 0,
                      dis_out_tquantity: 0,
                    }
                  ];
                }
                // Sum quantities of children and assign to inbound_contractData[ind].children
                if (rec.children && rec.children.length > 0) {
                  rec.children.forEach((child, childIndex) => {
                    inbound_contractData[ind].children[childIndex].quantity += parseFloat(child.quantity) || 0;
                    inbound_contractData[ind].children[childIndex].dis_quantity += parseFloat(child.dis_quantity) || 0;
                    inbound_contractData[ind].children[childIndex].in_quantity += parseFloat(child.in_quantity) || 0;
                    inbound_contractData[ind].children[childIndex].out_quantity += parseFloat(child.out_quantity) || 0;
                    inbound_contractData[ind].children[childIndex].dis_in_quantity += parseFloat(child.dis_in_quantity) || 0;
                    inbound_contractData[ind].children[childIndex].dis_out_quantity += parseFloat(child.dis_out_quantity) || 0;

                    inbound_contractData[ind].children[childIndex].in_fquantity += parseFloat(child.in_fquantity) || 0;
                    inbound_contractData[ind].children[childIndex].out_fquantity += parseFloat(child.out_fquantity) || 0;
                    inbound_contractData[ind].children[childIndex].dis_in_fquantity += parseFloat(child.dis_in_fquantity) || 0;
                    inbound_contractData[ind].children[childIndex].dis_out_fquantity += parseFloat(child.dis_out_fquantity) || 0;
                    inbound_contractData[ind].children[childIndex].in_tquantity += parseFloat(child.in_tquantity) || 0;
                    inbound_contractData[ind].children[childIndex].out_tquantity += parseFloat(child.out_tquantity) || 0;
                    inbound_contractData[ind].children[childIndex].dis_in_tquantity += parseFloat(child.dis_in_tquantity) || 0;
                    inbound_contractData[ind].children[childIndex].dis_out_tquantity += parseFloat(child.dis_out_tquantity) || 0;
                  });
                }
              }
            });
            inboundStatistics.total_count += 1;
            if (item.status === 'Finalized' || item.status === 'Pending' || item.status === 'Approved') {
              inboundStatistics.finalized_count += 1;
            }
            if (item.status === '' || item.status === null || item.status === 'Not Finalized') {
              inboundStatistics.pending_count += 1;
            }
            if (item.status === 'Rejected') {
              inboundStatistics.rejected_count += 1;
            }
            if ((item.status === 'Pending' && item.approved_acc === true) || (item.status === 'Approved' && item.approved_acc === true)) {
              inboundStatistics.approved_acc_count += 1;
            } else if (item.status === 'Approved' && item.approved_air === true) {
              inboundStatistics.approved_air_count += 1;
            }
          });
          let outbound_contractData = [];
          let outboundStatistics = {
            total_count: 0,
            finalized_count: 0,
            pending_count: 0,
            rejected_count: 0,
            approved_acc_count: 0,
            approved_air_count: 0
          };
          data.data.outflightcontracts.map((item, i) => {
            data.data.outflightcontracts[i].contractData = data.data.outflightcontracts[i].contractData.map((item, index) => ({
              ...cloneDeep(item),
              id: `${index + 1}_outflight`,
              row_id: item.id,
              item: item.label,
              driver: item.applied_on?.split('|')[0].trim(),
              source: item.applied_on?.split('|')[1].trim(),
              position: item.position,
            }));
            item.contractData.map((rec) => {
              let ind = outbound_contractData.findIndex((obj) => obj.contractId === rec.contractId && obj.cont_rowId === rec.cont_rowId);
              if (ind === -1) {
                outbound_contractData.push(cloneDeep(rec));
              }
              else {
                outbound_contractData[ind].quantity = (!isNaN(outbound_contractData[ind].quantity) ? parseFloat(outbound_contractData[ind].quantity) : 0) + parseFloat(rec.quantity) || 0;
                outbound_contractData[ind].totalrate = (!isNaN(outbound_contractData[ind].totalrate) ? parseFloat(outbound_contractData[ind].totalrate) : 0) + parseFloat(rec.totalrate) || 0;
                outbound_contractData[ind].dis_quantity = (!isNaN(outbound_contractData[ind].dis_quantity) ? parseFloat(outbound_contractData[ind].dis_quantity) : 0) + parseFloat(rec.dis_quantity) || 0;
                outbound_contractData[ind].dis_totalrate = (!isNaN(outbound_contractData[ind].dis_totalrate) ? parseFloat(outbound_contractData[ind].dis_totalrate) : 0) + parseFloat(rec.dis_totalrate) || 0;
                outbound_contractData[ind].in_quantity = (!isNaN(outbound_contractData[ind].in_quantity) ? parseFloat(outbound_contractData[ind].in_quantity) : 0) + parseFloat(rec.in_quantity) || 0;
                outbound_contractData[ind].in_totalrate = (!isNaN(outbound_contractData[ind].in_totalrate) ? parseFloat(outbound_contractData[ind].in_totalrate) : 0) + parseFloat(rec.in_totalrate) || 0;
                outbound_contractData[ind].out_quantity = (!isNaN(outbound_contractData[ind].out_quantity) ? parseFloat(outbound_contractData[ind].out_quantity) : 0) + parseFloat(rec.out_quantity) || 0;
                outbound_contractData[ind].out_totalrate = (!isNaN(outbound_contractData[ind].out_totalrate) ? parseFloat(outbound_contractData[ind].out_totalrate) : 0) + parseFloat(rec.out_totalrate) || 0;
                outbound_contractData[ind].dis_in_quantity = (!isNaN(outbound_contractData[ind].dis_in_quantity) ? parseFloat(outbound_contractData[ind].dis_in_quantity) : 0) + parseFloat(rec.dis_in_quantity) || 0;
                outbound_contractData[ind].dis_in_totalrate = (!isNaN(outbound_contractData[ind].dis_in_totalrate) ? parseFloat(outbound_contractData[ind].dis_in_totalrate) : 0) + parseFloat(rec.dis_in_totalrate) || 0;
                outbound_contractData[ind].dis_out_quantity = (!isNaN(outbound_contractData[ind].dis_out_quantity) ? parseFloat(outbound_contractData[ind].dis_out_quantity) : 0) + parseFloat(rec.dis_out_quantity) || 0;
                outbound_contractData[ind].dis_out_totalrate = (!isNaN(outbound_contractData[ind].dis_out_totalrate) ? parseFloat(outbound_contractData[ind].dis_out_totalrate) : 0) + parseFloat(rec.dis_out_totalrate) || 0;

                outbound_contractData[ind].in_fquantity = (!isNaN(outbound_contractData[ind].in_fquantity) ? parseFloat(outbound_contractData[ind].in_fquantity) : 0) + parseFloat(rec.in_fquantity) || 0;
                outbound_contractData[ind].out_fquantity = (!isNaN(outbound_contractData[ind].out_fquantity) ? parseFloat(outbound_contractData[ind].out_fquantity) : 0) + parseFloat(rec.out_fquantity) || 0;
                outbound_contractData[ind].dis_in_fquantity = (!isNaN(outbound_contractData[ind].dis_in_fquantity) ? parseFloat(outbound_contractData[ind].dis_in_fquantity) : 0) + parseFloat(rec.dis_in_fquantity) || 0;
                outbound_contractData[ind].dis_out_fquantity = (!isNaN(outbound_contractData[ind].dis_out_fquantity) ? parseFloat(outbound_contractData[ind].dis_out_fquantity) : 0) + parseFloat(rec.dis_out_fquantity) || 0;
                outbound_contractData[ind].in_tquantity = (!isNaN(outbound_contractData[ind].in_tquantity) ? parseFloat(outbound_contractData[ind].in_tquantity) : 0) + parseFloat(rec.in_tquantity) || 0;
                outbound_contractData[ind].out_tquantity = (!isNaN(outbound_contractData[ind].out_tquantity) ? parseFloat(outbound_contractData[ind].out_tquantity) : 0) + parseFloat(rec.out_tquantity) || 0;
                outbound_contractData[ind].dis_in_tquantity = (!isNaN(outbound_contractData[ind].dis_in_tquantity) ? parseFloat(outbound_contractData[ind].dis_in_tquantity) : 0) + parseFloat(rec.dis_in_tquantity) || 0;
                outbound_contractData[ind].dis_out_tquantity = (!isNaN(outbound_contractData[ind].dis_out_tquantity) ? parseFloat(outbound_contractData[ind].dis_out_tquantity) : 0) + parseFloat(rec.dis_out_tquantity) || 0;

                // Initialize all quantities of outbound_contractData[ind].children to 0
                if (!outbound_contractData[ind].children || outbound_contractData[ind].children.length === 0) {
                  outbound_contractData[ind].children = rec.children ? rec.children.map(child => ({
                    ...child,
                    quantity: 0,
                    dis_quantity: 0,
                    in_quantity: 0,
                    out_quantity: 0,
                    dis_in_quantity: 0,
                    dis_out_quantity: 0,

                    in_fquantity: 0,
                    out_fquantity: 0,
                    dis_in_fquantity: 0,
                    dis_out_fquantity: 0,
                    in_tquantity: 0,
                    out_tquantity: 0,
                    dis_in_tquantity: 0,
                    dis_out_tquantity: 0,
                  })) : [
                    {
                      quantity: 0,
                      dis_quantity: 0,
                      in_quantity: 0,
                      out_quantity: 0,
                      dis_in_quantity: 0,
                      dis_out_quantity: 0,

                      in_fquantity: 0,
                      out_fquantity: 0,
                      dis_in_fquantity: 0,
                      dis_out_fquantity: 0,
                      in_tquantity: 0,
                      out_tquantity: 0,
                      dis_in_tquantity: 0,
                      dis_out_tquantity: 0,
                    }
                  ];
                }
                // Sum quantities of children and assign to outbound_contractData[ind].children
                if (rec.children && rec.children.length > 0) {
                  rec.children.forEach((child, childIndex) => {
                    outbound_contractData[ind].children[childIndex].quantity += parseFloat(child.quantity) || 0;
                    outbound_contractData[ind].children[childIndex].dis_quantity += parseFloat(child.dis_quantity) || 0;
                    outbound_contractData[ind].children[childIndex].in_quantity += parseFloat(child.in_quantity) || 0;
                    outbound_contractData[ind].children[childIndex].out_quantity += parseFloat(child.out_quantity) || 0;
                    outbound_contractData[ind].children[childIndex].dis_in_quantity += parseFloat(child.dis_in_quantity) || 0;
                    outbound_contractData[ind].children[childIndex].dis_out_quantity += parseFloat(child.dis_out_quantity) || 0;

                    outbound_contractData[ind].children[childIndex].in_fquantity += parseFloat(child.in_fquantity) || 0;
                    outbound_contractData[ind].children[childIndex].out_fquantity += parseFloat(child.out_fquantity) || 0;
                    outbound_contractData[ind].children[childIndex].dis_in_fquantity += parseFloat(child.dis_in_fquantity) || 0;
                    outbound_contractData[ind].children[childIndex].dis_out_fquantity += parseFloat(child.dis_out_fquantity) || 0;
                    outbound_contractData[ind].children[childIndex].in_tquantity += parseFloat(child.in_tquantity) || 0;
                    outbound_contractData[ind].children[childIndex].out_tquantity += parseFloat(child.out_tquantity) || 0;
                    outbound_contractData[ind].children[childIndex].dis_in_tquantity += parseFloat(child.dis_in_tquantity) || 0;
                    outbound_contractData[ind].children[childIndex].dis_out_tquantity += parseFloat(child.dis_out_tquantity) || 0;
                  });
                }
              }
            });
            outboundStatistics.total_count += 1;
            if (item.status === 'Finalized' || item.status === 'Pending' || item.status === 'Approved') {
              outboundStatistics.finalized_count += 1;
            }
            if (item.status === '' || item.status === null || item.status === 'Not Finalized') {
              outboundStatistics.pending_count += 1;
            }
            if (item.status === 'Rejected') {
              outboundStatistics.rejected_count += 1;
            }
            if ((item.status === 'Pending' && item.approved_acc === true) || (item.status === 'Approved' && item.approved_acc === true)) {
              outboundStatistics.approved_acc_count += 1;
            } else if (item.status === 'Approved' && item.approved_air === true) {
              outboundStatistics.approved_air_count += 1;
            }
          });
          flightdata = data.data.inflightcontracts.concat(data.data.outflightcontracts);

          let day_contractData = [];
          data.data.daycontracts.map((item, i) => {
            data.data.daycontracts[i].contractData = data.data.daycontracts[i].contractData.map((item, index) => ({
              ...cloneDeep(item),
              id: `${index + 1}_daylog`,
              row_id: item.id,
              item: item.label,
              driver: item.applied_on?.split('|')[0].trim(),
              source: item.applied_on?.split('|')[1].trim(),
              position: item.position,
            }));

            item.contractData.map((rec) => {
              let index = day_contractData.findIndex((obj) => obj.contractId === rec.contractId && obj.cont_rowId === rec.cont_rowId);
              if (index === -1) {
                day_contractData.push(cloneDeep(rec));
              }
              else {
                day_contractData[index].quantity = rec.quantity ? parseFloat(day_contractData[index].quantity) + parseFloat(rec.quantity) : parseFloat(day_contractData[index].quantity);
                day_contractData[index].totalrate = rec.totalrate ? parseFloat(day_contractData[index].totalrate) + parseFloat(rec.totalrate) : parseFloat(day_contractData[index].totalrate);
              }
            });
          });
          let month_contractData = [];
          data.data.monthcontracts.map((item, i) => {
            data.data.monthcontracts[i].contractData = data.data.monthcontracts[i].contractData.map((item, index) => ({
              ...cloneDeep(item),
              id: `${index + 1}_monthlog`,
              row_id: item.id,
              item: item.label,
              driver: item.applied_on?.split('|')[0].trim(),
              source: item.applied_on?.split('|')[1].trim(),
              position: item.position,
            }));

            item.contractData.map((rec) => {
              let index = month_contractData.findIndex((obj) => obj.contractId === rec.contractId && obj.cont_rowId === rec.cont_rowId);
              if (index === -1) {
                month_contractData.push(cloneDeep(rec));
              }
              // else {
              //   month_contractData[index].quantity = parseFloat(month_contractData[index].quantity) + parseFloat(rec.quantity);
              //   month_contractData[index].totalrate = parseFloat(month_contractData[index].totalrate) + parseFloat(rec.totalrate);
              // }
            });
          });

          let inbound = {
            id: 'inbound',
            label: `${data.data.inflightcontracts.length} Inbound Flights`,
            flight_count: data.data.inflightcontracts.length,
            flights: data.data.inflightcontracts,
            contractData: inbound_contractData.map((item, index) => ({
              ...item,
              id: `${index + 1}_daylog`,
              row_id: item.id,
              item: item.label,
              driver: item.applied_on?.split('|')[0].trim(),
              source: item.applied_on?.split('|')[1].trim(),
              position: item.position,
            })), // Need to add ids
            transit_awbs: [],
            inboundStatistics: inboundStatistics,
          };
          let outbound = {
            id: 'outbound',
            label: `${data.data.outflightcontracts.length} Outbound Flights`,
            flight_count: data.data.outflightcontracts.length,
            flights: data.data.outflightcontracts,
            contractData: outbound_contractData.map((item, index) => ({
              ...item,
              id: `${index + 1}_daylog`,
              row_id: item.id,
              item: item.label,
              driver: item.applied_on?.split('|')[0].trim(),
              source: item.applied_on?.split('|')[1].trim(),
              position: item.position,
            })), // Need to Sum up all outbound data
            transit_awbs: [],
            outboundStatistics: outboundStatistics,
          };
          let daylog = {
            id: 'daylog',
            label: `${data.data.daycontracts.length} Day Logs`,
            daylog_count: data.data.daycontracts.length, // Need to replace this with alldaylogs count
            daylogs: data.data.daycontracts,
            alldaylogs: data.data.daycontracts, // need to change this
            contractData: day_contractData.map((item, index) => ({
              ...item,
              id: `${index + 1}_daylog`,
              row_id: item.id,
              item: item.label,
              driver: item.applied_on?.split('|')[0].trim(),
              source: item.applied_on?.split('|')[1].trim(),
              position: item.position,
            })), // Need to Sum up all daylogs data
          };
          let monthlog = {
            id: 'monthlog',
            label: `${data.data.monthcontracts.length} Month Logs`,
            monthlog_count: 1,
            monthlogs: data.data.monthcontracts,
            allmonthlogs: data.data.monthcontracts, // need to change this
            contractData: month_contractData.map((item, index) => ({
              ...item,
              id: `${index + 1}_monthlog`,
              row_id: item.id,
              item: item.label,
              driver: item.applied_on?.split('|')[0].trim(),
              source: item.applied_on?.split('|')[1].trim(),
              position: item.position,
            })), // Need to Sum up all monthlogs data
          };

          console.log('data.data?.airlinecontracts[0]?.label', data.data?.airlinecontracts[0]?.label);
          const quantityFields = [
            'quantity', 'dis_quantity',
            'in_quantity', 'out_quantity', 'dis_in_quantity', 'dis_out_quantity',
            'in_fquantity', 'out_fquantity', 'dis_in_fquantity', 'dis_out_fquantity',
            'in_tquantity', 'out_tquantity', 'dis_in_tquantity', 'dis_out_tquantity',
          ];
          const flightContractData = [...inbound.contractData, ...outbound.contractData];
          let airline_data = {
            id: data.data?.airlinecontracts[0]?.label,
            label: `${parseInt(data.data.inflightcontracts.length) + parseInt(data.data.outflightcontracts.length)} ${(this.state.airlineCode + ' Flights')}`,
            flight_count: parseInt(data.data.inflightcontracts.length) + parseInt(data.data.outflightcontracts.length),
            inbound: inbound,
            outbound: outbound,
            contractData: data.data.airlinecontracts[0]?.contractData.map((item, index) => {
              const driver = item.applied_on?.split('|')[0].trim();
              const source = item.applied_on?.split('|')[1].trim();
              const matchingRows = flightContractData.filter((row) =>
                row.label === item.label && row.driver === driver && row.source === source
              );
              const quantities = {};
              quantityFields.forEach((field) => {
                quantities[field] = matchingRows.reduce((total, row) => total + (parseFloat(row[field]) || 0), 0);
              });
              return {
                ...item,
                ...quantities,
                id: `${index + 1}_daylog`,
                row_id: item.id,
                item: item.label,
                driver: driver,
                source: source,
                position: item.position,
              };
            }) || [],
            transit_awbs: [],
            daylog: daylog,
            monthlog: monthlog,
          };
          billingData.push(airline_data);
          let contractData = [];
          let dayContractData = [];
          let monthContractData = [];
          let accord_id = null;
          let accord_type = null;
          let daylogdata = [];
          let monthlogdata = [];
          if (billingData.length > 0) {
            alcontractsData = billingData[0]?.contractData;
            contractData = billingData[0]?.contractData;
            accord_id = billingData[0]?.id;
            accord_type = 'airline';
            dayContractData = billingData[0]?.daylog?.contractData;
            monthContractData = billingData[0]?.monthlog?.contractData;
            daylogdata = billingData[0]?.daylog?.alldaylogs;
            monthlogdata = billingData[0]?.monthlog?.allmonthlogs;
          }
          // console.log('billingData', billingData);
          // console.log('flightdata', flightdata);
          // console.log('invoicedata', invoicedata);
          // console.log('daylogdata*************', daylogdata);
          // console.log('monthlogdata***********', monthlogdata);
          // console.log('contractData', contractData);
          // console.log('dayContractData', dayContractData);
          // console.log('monthContractData', monthContractData);
          // console.log('customReportOptions', customReportOptions);
          flightdata = flightdata.map((item) => ({
            ...item,
            contractData: item.contractData.filter((contract) => contract.is_nonbillable !== true),
            transit_awbs: item.transit_awbs || [],
          }));
          if(!callType){
            this.setState({
              flightdata: flightdata || [],
              invoicedata: invoicedata || [],
              billingData: billingData || [],
              csvContracts: csvContracts || [],
              daylogdata: daylogdata || [],
              monthlogdata: monthlogdata || [],
              alcontractsData: alcontractsData,
              contractData: contractData || [],
              transit_awbs: data.data.transit_awbs || [],
              dayContractData: dayContractData || [],
              monthContractData: monthContractData || [],
              invoice_info: invoice_info || null,
              accord_id: accord_id,
              accord_type: accord_type,
              genInvProgress: false,
              customReportOptions: customReportOptions,
            }, () => {
              this.filter();
              if (this.state.billingFields.transit === 'inbound' || this.state.billingFields.transit === 'outbound') {
                this.filterData();
                if (callback) return callback(true, contractData, csvContracts, daylogdata, monthlogdata, billingData);
              } else {
                if (callback) return callback(true, contractData, csvContracts, daylogdata, monthlogdata, billingData);
              }
            });
          } else {
            if (this.state.billingFields.transit === 'inbound' || this.state.billingFields.transit === 'outbound') {
              if (callback) return callback(true, contractData, csvContracts, daylogdata, monthlogdata, billingData);
            } else {
              if (callback) return callback(true, contractData, csvContracts, daylogdata, monthlogdata, billingData);
            }
          }
        });
    } else {
      this.setState({ genInvProgress: false });
      if (callback) return callback(true);
    }
  };

  fetchDiscrepancies = (type = null, callType = null, callback = null) => {
    let from = moment(this.state.searchFields.from).format('YYYY-MM-DD');
    let to = moment(this.state.searchFields.to).format('YYYY-MM-DD');
    if (this.state.searchFields.month) {
      if (this.state.searchFields.period === 'month') {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
      } else if (this.state.searchFields.period === 'first') {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').add(14, 'days').format('YYYY-MM-DD');
      } else {
        from = moment(this.state.searchFields.month, 'YYYY-MM').startOf('month').add(15, 'days').format('YYYY-MM-DD');
        to = moment(this.state.searchFields.month, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
      }
    }
    let dateType = 'actual';
    if(this.state.billingFields.dateType === 'scheduled'){
      dateType = 'scheduled';
    }
    if (this.state.searchFields.airline) {
      http.get(`/billing/discrepancy?from=${from}&to=${to}&station=${this.station_code}&airline=${this.state.searchFields.airline}&datetype=${dateType}`)
        .then(({ data }) => {
          if(!callType)
            this.setState({ flightList: data.data });
          let discrepancyCountInbound = data.data[0]?.inbound.map((inbound) => inbound?.flight_discrepancies.length).reduce((a, b) => a + b, 0);
          let discrepancyCountOutbound = data.data[0]?.outbound.map((outbound) => outbound?.flight_discrepancies.length).reduce((a, b) => a + b, 0);
          let discrepancyCount = discrepancyCountInbound + discrepancyCountOutbound;
          if (type === 'count') {
            if(!callType)
              this.setState({ discrepancyCount });
          }
          else {
            if (data.data && data.data.length > 0) {
              let billingData = [];
              data.data.forEach((airline) => {
                let inbound = {};
                let outbound = {};
                let inbound_data = [];
                let outbound_data = [];

                let ib_flight_count = 0;

                if (airline?.inbound?.length > 0) {
                  ib_flight_count = airline?.inbound?.length;
                  airline?.inbound.map((inflight) => {
                    let flight_discrepancies = inflight?.flight_discrepancies || [];
                    let flight = {
                      id: inflight?.id,
                      row_id: inflight?.id,
                      flight_no: inflight?.flight_no,
                      label: `${airline?.code}${inflight?.flight_no}/${moment(inflight?.flight_date, 'YYYY-MM-DD').format('DDMMMYY')} (${inflight?.org}-${inflight?.dest})`,
                      act_arr: inflight?.act_arr,
                      act_dept: inflight?.act_dept,
                      schdl_arr: inflight?.schdl_arr,
                      schdl_dept: inflight?.schdl_dept,
                      org: inflight?.org,
                      dest: inflight?.dest,
                      url: `/flight_folder/discrepancies?id=${inflight.id}`,
                      flight_schedule_id: inflight?.flight_schedule_id,
                      flight_count: 1,
                      contractData: flight_discrepancies,
                      transit_awbs: [],
                    };
                    inbound_data.push(flight);
                  });
                }
                let inboundData = inbound_data.map(obj => obj.contractData).flat();
                let inboundDiscType = [];
                inboundData?.map((discrepancy) => {
                  inboundDiscType.push(discrepancy.type);
                });
                let typeObj = {
                  'Missing Airwaybill': 0,
                  'Missing Cargo': 0,
                  'Found Cargo': 0,
                  'Found Airwaybill': 0,
                  'Short Shipped': 0,
                  'Over Carried': 0,
                  'Damaged Cargo': 0,
                  'Other': 0
                };
                inboundDiscType.forEach(type => {
                  if (typeObj[type]) {
                    typeObj[type]++;
                  }
                  else {
                    typeObj[type] = 1;
                  }
                });
                inbound = {
                  id: `${airline?.id}_inbound`,
                  label: `${ib_flight_count} Inbound Flights`,
                  flight_count: ib_flight_count,
                  flights: inbound_data,
                  contractData: inbound_data.map(obj => obj.contractData).flat(),
                  transit_awbs: [],
                  ...typeObj
                };

                let ob_flight_count = 0;

                if (airline?.outbound?.length > 0) {
                  ob_flight_count = airline?.outbound?.length;
                  airline?.outbound.map((outflight) => {
                    let flight_discrepancies = outflight?.flight_discrepancies || [];
                    let flight = {
                      id: outflight?.id,
                      row_id: outflight?.id,
                      flight_no: outflight?.flight_no,
                      label: `${airline?.code}${outflight?.flight_no}/${moment(outflight?.flight_date, 'YYYY-MM-DD').format('DDMMMYY')} (${outflight?.org}-${outflight?.dest})`,
                      act_arr: outflight?.act_arr,
                      act_dept: outflight?.act_dept,
                      schdl_arr: outflight?.schdl_arr,
                      schdl_dept: outflight?.schdl_dept,
                      org: outflight?.org,
                      dest: outflight?.dest,
                      url: `/flight_folder/discrepancies?id=${outflight.id}`,
                      flight_schedule_id: outflight?.flight_schedule_id,
                      flight_count: 1,
                      contractData: flight_discrepancies,
                      transit_awbs: [],
                    };
                    outbound_data.push(flight);

                  });
                }

                let outboundData = outbound_data.map(obj => obj.contractData).flat();
                let outDiscType = [];
                outboundData?.map((discrepancy) => {
                  outDiscType.push(discrepancy.type);
                });
                let outTypeObj = {
                  'Missing Airwaybill': 0,
                  'Missing Cargo': 0,
                  'Found Cargo': 0,
                  'Found Airwaybill': 0,
                  'Short Shipped': 0,
                  'Over Carried': 0,
                  'Damaged Cargo': 0,
                  'Other': 0
                };
                outDiscType.forEach(type => {
                  if (outTypeObj[type]) {
                    outTypeObj[type]++;
                  }
                  else {
                    outTypeObj[type] = 1;
                  }
                });
                outbound = {
                  id: `${airline?.id}_outbound`,
                  label: `${ob_flight_count} Outbound Flights`,
                  flight_count: ob_flight_count,
                  flights: outbound_data,
                  contractData: outbound_data.map(obj => obj.contractData).flat(),
                  transit_awbs: [],
                  ...outTypeObj
                };

                let airline_data = {
                  id: airline?.id,
                  label: `${parseInt(ib_flight_count) + parseInt(ob_flight_count)} ${airline?.code} Flights`,
                  flight_count: ib_flight_count + ob_flight_count,
                  inbound: inbound,
                  outbound: outbound,
                  contractData: [...inbound.contractData, ...outbound.contractData],
                  transit_awbs: [],
                  'Missing Airwaybill': inbound['Missing Airwaybill'] + outbound['Missing Airwaybill'] || 0,
                  'Missing Cargo': inbound['Missing Cargo'] + outbound['Missing Cargo'] || 0,
                  'Found Cargo': inbound['Found Cargo'] + outbound['Found Cargo'] || 0,
                  'Found Airwaybill': inbound['Found Airwaybill'] + outbound['Found Airwaybill'] || 0,
                  'Short Shipped': inbound['Short Shipped'] + outbound['Short Shipped'] || 0,
                  'Over Carried': inbound['Over Carried'] + outbound['Over Carried'] || 0,
                  'Damaged Cargo': inbound['Damaged Cargo'] + outbound['Damaged Cargo'] || 0,
                  'Other': inbound['Other'] + outbound['Other'] || 0,
                };
                billingData.push(airline_data);
              });
              // let contractData = [];
              let accord_id = null;
              let accord_type = null;
              if (billingData.length > 0) {
                // contractData = billingData[0]?.contractData;
                accord_id = billingData[0]?.id;
                accord_type = 'airline';
              }
              if(!callType){
                this.setState({
                  billingData: billingData,
                  // contractData: contractData,
                  accord_id: accord_id,
                  accord_type: accord_type,
                  discrepancyCount
                }, () => {
                  this.filter();
                  if (this.state.billingFields.transit === 'inbound' || this.state.billingFields.transit === 'outbound') {
                    this.filterData();
                    if (callback)
                      return callback(true, data.data );
                  } else {
                    if (callback) {
                      this.filterData();
                      return callback(true, data.data);
                    }
                  }
                });
              } else {
                if (callback)
                  return callback(true, data.data);
              }
            } else {
              if(!callType){
                this.setState({ billingData: [] });
              }
              if (callback)
                return callback(true, data.data);
            }
          }
        });
    }
  };

  setSummary = (data) => {
    this.setState({ summaryData: data && data[0] });
  };

  setContTBData = (data, type) => {
    // console.log('setContTBData%%%%%%%%%%%%%%%%%%%%%%%%%%%5', data, type);
    let transit_awbs = [];
    if(type === 'inbound_flight' || type === 'outbound_flight') {
      transit_awbs = data?.transit_awbs || [];
      // filter out by label and flight_no and flight_date
      if(type === 'inbound_flight'){
        // label format = "LH345/01Jun26 (MIA-LAX)"
        transit_awbs = transit_awbs.filter((item) => {
          let flightlabel = item.inboundInfo?.flight?.airline+item.inboundInfo?.flight?.flight_no+'/'+moment(item.inboundInfo?.flight?.flight_date).format('DDMMMYY')+' ('+item.inboundInfo?.flight?.org+'-'+item.inboundInfo?.flight?.dest+')';
          return flightlabel === data?.label;
        });
      } else if(type === 'outbound_flight'){
        transit_awbs = transit_awbs.filter((item) => {
          let flightlabel = item.outboundInfo?.flight?.airline+item.outboundInfo?.flight?.flight_no+'/'+moment(item.outboundInfo?.flight?.flight_date).format('DDMMMYY')+' ('+item.outboundInfo?.flight?.org+'-'+item.outboundInfo?.flight?.dest+')';
          return flightlabel === data?.label;
        });
      }
    }
    // console.log('&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&7transit_awbs', transit_awbs);
    if (type === 'airline') {
      this.setState({ showSummary: true });
    } else {
      this.setState({ showSummary: false });
    }
    //sort data?.contractData by position before setting state
    if (data?.contractData) {
      data.contractData.sort((a, b) => a.position - b.position);
    }
    this.setState({ 
      contractData: [], 
      transit_awbs: [] 
    }, () =>
      this.setState({
        summaryData: data,
        contractData: data?.contractData,
        transit_awbs: transit_awbs,
        accord_id: data?.id,
        accord_type: type,
      })
    );
  };

  changeCheck = (e) => {
    this.setState({
      billingFields: {
        ...this.state.billingFields,
        [e.target.name]: e.target.checked
      }
    }, () => {
      if (e.target.name === 'exclude_disc') {
        this.generateBillingColumns();
      }
    });
  };

  onChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let priority = this.state.billingFields.priority;
    if(name === 'priority') {
      priority = value;
    } else if(name === 'transit' && ( value === 'flight' || value === 'truck')) {
      priority = 'outbound';
    } else {
      priority = 'none';
    }
    this.setState({
      billingFields: {
        ...this.state.billingFields,
        [name]: value,
        priority: priority
      }
    }, () => {
      if ((name === 'transit' && (value === 'inbound' || value === 'outbound' || value === 'flight' || value === 'truck')) || name === 'priority') {
        this.filterData();
      }
      if(name === 'dateType') {
        if(this.state.loadInfo === 'contract_data' || this.state.loadInfo === 'statistics') {
          this.fetchInvoiceData();
        } else if(this.state.loadInfo === 'statistics_summary'){
          this.fetchProducts();
        } else {
          this.fetchDiscrepancies();
        }
      }
    });
  };

  changeDateAndTime = (element, type) => {
    this.setState({
      flightFields: {
        ...this.state.flightFields,
        [type]: (type == 'sta_time' || type == 'std_time') ? element.target.value : element.format('YYYY-MM-DD')
      }
    });
  };

  handleContractType = (e) => {
    let cont_item = contractType[e.target.value];
    this.setState({
      contract_Type: e.target.value,
      cont_item: cont_item,
    }, () => {
      if (this.state.loadInfo === 'statistics_summary') {
        this.fetchProducts();
      } else if (this.state.loadInfo === 'contract_data' || this.state.loadInfo === 'statistics') {
        this.fetchInvoiceData();
      }
    });
    //call function to filter by contracttype
  };

  addFlight = (e) => {
    e.preventDefault();
    const { flightFields } = this.state;
    let formdata = {
      airline: flightFields.airline,
      flight_no: flightFields.flight_no,
      flight_date: flightFields.flight_date,
      org: flightFields.org,
      dest: flightFields.dest,
      schdl_dept: flightFields.schdl_dept,
      schdl_arr: flightFields.schdl_arr,
      ac_type: flightFields.ac_type,
      platform: flightFields.platform
    };
    if (this.validation()) {
      http.post('/flight', formdata)
        .then(() => {
          this.setState((prev) => ({
            flightFields: {
              airline: '',
              flight_no: '',
              flight_date: '',
              org: '',
              dest: '',
              schdl_dept: '',
              schdl_arr: '',
              ac_type: '',
              platform: ''
            },
            modal: prev.modal === 'adhoc_flight' ? false : null
          }));
        });
    }
  };

  validation = () => {
    const flightFields = { ...this.state.flightFields };
    const error = {};
    let formValid = true;
    if (!flightFields.airline || (flightFields.airline.trim().length === 0)) {
      formValid = false;
      error.airline = 'Please select an airline';
    }
    if (!flightFields.platform || (flightFields.platform.trim().length === 0)) {
      formValid = false;
      error.platform = 'Please enter a platform';
    }
    if (!flightFields.flight_no || (flightFields.flight_no.trim().length === 0)) {
      formValid = false;
      error.flight_no = 'Please enter flight number';
    }
    if (!flightFields.flight_date || (flightFields.flight_date.trim().length === 0)) {
      formValid = false;
      error.flight_date = 'Please enter flight date';
    }
    if (!flightFields.org || (flightFields.org.trim().length === 0)) {
      formValid = false;
      error.org = 'Please Select org';
    }
    if (!flightFields.dest || (flightFields.dest.trim().length === 0)) {
      formValid = false;
      error.dest = 'Please enter dest';
    }
    if (!flightFields.ac_type || (flightFields.ac_type.trim().length === 0)) {
      formValid = false;
      error.ac_type = 'Please enter Aircraft type';
    }
    if (!flightFields.schdl_dept || (flightFields.schdl_dept.trim().length === 0)) {
      formValid = false;
      error.schdl_dept = 'Please enter a STD';
    }
    if (!flightFields.schdl_arr || (flightFields.schdl_arr.trim().length === 0)) {
      formValid = false;
      error.schdl_arr = 'Please enter a STA';
    }
    this.setState({ flightErrors: error });
    return formValid;
  };


  editFlight = (e) => {
    e.preventDefault();
    const { flightFields } = this.state;
    let formdata = {
      airline: flightFields.airline,
      flight_no: flightFields.flight_no,
      flight_date: flightFields.flight_date,
      org: flightFields.org,
      dest: flightFields.dest,
      schdl_dept: flightFields.schdl_dept,
      schdl_arr: flightFields.schdl_arr,
      ac_type: flightFields.ac_type,
      platform: flightFields.platform
    };
    if (this.validation()) {
      http.put(`/flight/${flightFields.id}`, formdata)
        .then(() => {
          this.setState((prev) => ({
            flightFields: {
              airline: '',
              flight_no: '',
              flight_date: '',
              org: '',
              dest: '',
              schdl_dept: '',
              schdl_arr: '',
              ac_type: '',
              platform: ''
            },
            modal: prev.modal === 'adhoc_flight' ? false : null
          }));
        });
    }
  };

  deleteFlight = (id) => {
    http.delete('/flight/' + id).then(({ data }) => {
      if (data.status == 'success') {
        this.props.setDelete();
      }
    });
  };

  handleDelete = (id, anchorEl) => {
    this.props.setDelete({
      modal: true,
      id,
      anchorEl,
      onConfirm: () => this.deleteFlight(id),
    });
  };

  handleOpen = (modal, action, data = {}) => {
    if(modal === 'downloadProgress') {
      // call PUT API verify_download_invoice/:id, if success start progress count. pass user id
      http.put(`/verify_download_invoice/${cookies.get('user')}`)
        .then((response) => {
          if(response.data.data.access === true) {
            if (this.progressInterval) clearInterval(this.progressInterval);
            this.progressInterval = setInterval(this.progressCount, 1000);
            this.setState({
              modal,
              action,
              flightFields: { ...data }
            });
          } else {
            toast.warning(response.data?.message);
          }
        });
    } else {
      this.setState({
        modal,
        action,
        flightFields: { ...data }
      });
    }
  };

  onClose = () => {
    this.setState({
      modal: false,
      action: false,
      sessionExpired: false,
      emailPassword: false
    });
  };

  handlePopover = (e, data) => {
    this.setState({
      anchorEl: e?.currentTarget,
      popoverData: data 
    });
  };

  handlePopoverClose = () => {
    this.setState({
      anchorEl: null,
      popoverData: null
    });
  };

  closePopover = () => {
    this.setState({ anchorEl: null });
  };

  handleChange = (panel) => (e, newExpanded) => {
    this.setState({ open: !this.state.open });
    if(panel === 'flight') {
      this.setState({ expandedFlight: newExpanded ? panel : false });
      return;
    }
    this.setState({ expanded: newExpanded ? panel : false });
    // setExpanded(newExpanded ? panel : false);
  };

  handleToggle = (e) => {
    // this.setState({ loadInfo: e.target.value, }, () => {
    this.props.handleSubToggle(e);
    if (e.target.value === 'contract_data' || e.target.value === 'statistics') {
      //fetch contracts
      this.fetchInvoiceData();
    } else if (e.target.value === 'statistics_summary') {
      this.setState({
        flightList: [],
        billingData: [],
        filteredData: [],
        contractData: [],
        transit_awbs: [],
        accord_id: null,
        accord_type: null,
      }, () => this.fetchProducts());
      //fetch billing
    } else if (e.target.value === 'discrepancy') {
      //fetch billing
      this.setState({
        flightList: [],
        billingData: [],
        filteredData: [],
        contractData: [],
        transit_awbs: [],
        accord_id: null,
        accord_type: null,
      }, () => this.fetchDiscrepancies());
    }
    // });
  };

  get_csv_cont = async () => { 
    let csv_cont = [];
    this.state.billingData.map((column) => {
      column?.inbound?.flights.map((flight) => {
        let data = {
          'Flight': flight.label?.split('/')?.[0],
          'Date':   flight.label?.split('/')?.[1],
          'Sch Arr Date': flight.schdl_arr ? getStationDate( flight.dest,flight.schdl_arr, 'DDMMMYY') : '',
          'Sch Dept Date': flight.schdl_dept ? getStationDate( flight.org,flight.schdl_dept, 'DDMMMYY') : '',
          'Act Arr Date': flight.act_arr ? getStationDate( flight.dest,flight.act_arr, 'DDMMMYY') : '',
          'Act Dept Date': flight.act_dept ? getStationDate( flight.org,flight.act_dept, 'DDMMMYY') : '',
          'Segment': `${flight.org} - ${flight.dest}`,
          'Type': 'Inbound'
        };
        flight?.contractData.filter(item => item.is_nonbillable !== true).map((row) => {
          data[row.item] = this.state.billingFields.exclude_disc ? row.quantity : row.dis_quantity;
        });
        csv_cont.push(data);
      });
      column?.outbound?.flights.map((flight) => {
        let data = {
          'Flight': flight.label?.split('/')?.[0],
          'Date':   flight.label?.split('/')?.[1],
          'Sch Arr Date': flight.schdl_arr ? getStationDate( flight.dest,flight.schdl_arr, 'DDMMMYY') : '',
          'Sch Dept Date': flight.schdl_dept ? getStationDate( flight.org,flight.schdl_dept, 'DDMMMYY') : '',
          'Act Arr Date': flight.act_arr ? getStationDate( flight.dest,flight.act_arr, 'DDMMMYY') : '',
          'Act Dept Date': flight.act_dept ? getStationDate( flight.org,flight.act_dept, 'DDMMMYY') : '',
          'Segment': `${flight.org} - ${flight.dest}`,
          'Type': 'Outbound'
        };
        flight?.contractData.filter(item => item.is_nonbillable !== true).map((row) => {
          data[row.item] = this.state.billingFields.exclude_disc ? row.quantity : row.dis_quantity;
        });
        csv_cont.push(data);
      });
    });
    return csv_cont;
  };

  get_csvpage_cont = async (sheetType) => {
  // This function generates a summary table from billingData, similar to get_csv_cont,
  // but sums up quantities for noncommercialData columns based on sheetType and removes unnecessary columns.

    let csv_cont = [];
    const excludeDisc = this.state.billingFields.exclude_disc;

    // Helper: For a given contractData array and commercial_items, sum up the quantities
    function sumCommercialItems(contractData, commercial_items, excludeDisc) {
      let sum = 0;
      contractData.forEach(row => {
        if (commercial_items.includes(parseInt(row.cont_rowId))) {
          sum += parseFloat(excludeDisc ? row.quantity : row.dis_quantity) || 0;
        }
      });
      return sum;
    }

    function groupAndSumRows(csv_cont) {
      const grouped = {};

      csv_cont.forEach(row => {
        const key = `${row.Flight}_${row.Type}`;
        if (!grouped[key]) {
          grouped[key] = { ...row };
        } else {
          Object.keys(row).forEach(col => {
            if (
              !['Flight', 'Date', 'Segment', 'Type'].includes(col) &&
              typeof row[col] === 'number'
            ) {
              grouped[key][col] = (grouped[key][col] || 0) + row[col];
            }
          });
        }
      });

      return Object.values(grouped);
    }

    // // Helper: Get all noncommercialData columns for this sheetType
    // function getNonCommercialColumns(noncommercialData, sheetType) {
    //   return (noncommercialData || []).filter(nc =>
    //     !nc.sheetlist || nc.sheetlist.includes(sheetType)
    //   );
    // }

    // Main logic
    this.state.billingData.forEach(column => {
      ['inbound', 'outbound'].forEach(type => {
        column?.[type]?.flights?.forEach(flight => {
          let data = {
            'Flight': flight.label?.split('/')?.[0],
            'Date': flight.label?.split('/')?.[1],
            'Segment': `${flight.org} - ${flight.dest}`,
            'Type': type.charAt(0).toUpperCase() + type.slice(1)
          };

          // If noncommercialData is present, sum up the columns
          if (flight.noncommercialData && Array.isArray(flight.noncommercialData) && sheetType) {
            // const nonCommercialCols = getNonCommercialColumns(flight.noncommercialData, sheetType);
            const nonCommercialCols = flight.noncommercialData;
            nonCommercialCols.forEach(nc => {
              // Sum up all contractData rows whose id is in nc.commercial_items
              const sum = sumCommercialItems(flight.contractData || [], nc.commercial_items || [], excludeDisc);
              data[nc.description] = sum;
            });
          }

          // Always include all contractData items as columns (like get_csv_cont)
          if (flight.contractData && Array.isArray(flight.contractData)) {
            flight.contractData.forEach(row => {
              data[row.item] = excludeDisc ? row.quantity : row.dis_quantity;
            });
          }

          csv_cont.push(data);
        });
      });
    });

    // If noncommercialData is present, remove columns that are not in noncommercialData for this sheetType
    // Otherwise, keep all columns as in get_csv_cont
    // (If you want to keep only noncommercialData columns, uncomment below)
    /*
    if (this.state.billingData.length > 0) {
      const firstFlight = (
        this.state.billingData[0]?.inbound?.flights?.[0] ||
        this.state.billingData[0]?.outbound?.flights?.[0]
      );
      if (firstFlight && firstFlight.noncommercialData && sheetType) {
        const nonCommercialCols = getNonCommercialColumns(firstFlight.noncommercialData, sheetType);
        const allowedCols = ['Flight', 'Date', 'Segment', 'Type', ...nonCommercialCols.map(nc => nc.description)];
        csv_cont = csv_cont.map(row => {
          let filtered = {};
          allowedCols.forEach(col => {
            if (row[col] !== undefined) filtered[col] = row[col];
          });
          return filtered;
        });
      }
    }
    */
    if (sheetType === 'Flight Summary'){
      if (this.state.reportFields.reportType === 'custom' && sheetType === 'Flight Summary'){
        if (
          Array.isArray(this.state.flightSumOpts) && this.state.flightSumOpts.length > 0
        ) {
          // Get allowed columns from fSumOpts
          const allowedCols = [
            'Flight',
            'Segment',
            'Type',
            ...this.state.flightSumOpts.map(opt => opt.title)
          ];

          csv_cont = csv_cont.map(row => {
            let filtered = {};
            allowedCols.forEach(col => {
              if (Object.prototype.hasOwnProperty.call(row, col)) filtered[col] = row[col];
            });
            return filtered;
          });
        }
      }
      csv_cont = groupAndSumRows(csv_cont);
    }

    else if (
      this.state.reportFields.reportType === 'custom' && sheetType === 'Flight Details' &&
      Array.isArray(this.state.flightDetOpts) && this.state.flightDetOpts.length > 0
    ) {
      // Get allowed columns from fDetOpts
      const allowedCols = [
        'Flight',
        'Date',
        'Segment',
        'Type',
        ...this.state.flightDetOpts.map(opt => opt.title)
      ];

      csv_cont = csv_cont.map(row => {
        let filtered = {};
        allowedCols.forEach(col => {
          if (Object.prototype.hasOwnProperty.call(row, col)) filtered[col] = row[col];
        });
        return filtered;
      });
    }
    return csv_cont;
  };
  
  get_tonnage_summary = async () => {
    const csvContracts = this.state.csvContracts || [];
    const contractData = this.state.contractData || [];
    let csv_cont = [];
    let sheetType = [
      'Flight Summary',
      'Flight Details'
    ];

    // 1. For each csvContract, sum up contractData records whose id is in commercial_items
    csvContracts.forEach(contract => {
      if (contract.sheetlist && !sheetType.some(type => contract.sheetlist.includes(type))) return;
      const ids = contract.commercial_items || [];
      // Find all contractData records with id in ids
      const matched = contractData.filter(row => ids.includes(row.row_id));
      // Sum up the fields
      let sum_quantity = 0, sum_dis_quantity = 0;
      let sum_driver = '', sum_source = '';
      matched.forEach(row => {
        sum_quantity += parseFloat(row.quantity) || 0;
        sum_dis_quantity += parseFloat(row.dis_quantity) || 0;
        // Use the first non-empty driver/source for display
        if (!sum_driver && row.applied_on) sum_driver = row.applied_on.split('|')[0]?.trim();
        if (!sum_source && row.applied_on) sum_source = row.applied_on.split('|')[1]?.trim();
      });
      // Only add if there is at least one matched record
      if (matched.length > 0) {
        csv_cont.push({
          'Item': contract.description,
          'Driver': sum_driver,
          'Source': sum_source,
          'Quantity': this.state.billingFields.exclude_disc ? sum_quantity : sum_dis_quantity,
        });
      }
    });

    // 2. For contractData records whose id is NOT present in any csvContract's commercial_items, add as-is
    let allCommercialIds = new Set();
    csvContracts.forEach(contract => {
      (contract.commercial_items || []).forEach(id => allCommercialIds.add(id));
    });
    contractData.forEach(row => {
      // if (!allCommercialIds.has(row.row_id)) {
      csv_cont.push({
        'Item': row.label,
        'Driver': row.applied_on ? row.applied_on.split('|')[0]?.trim() : '',
        'Source': row.applied_on ? row.applied_on.split('|')[1]?.trim() : '',
        'Quantity': this.state.billingFields.exclude_disc ? row.quantity : row.dis_quantity,
      });
      // }
    });

    if (
      this.state.reportFields.reportType === 'custom' &&
      Array.isArray(this.state.tonSumOpts) &&
      this.state.tonSumOpts.length > 0
    ) {
      const allowedItems = this.state.tonSumOpts.map(opt => opt.title);
      csv_cont = csv_cont.filter(row => allowedItems.includes(row.Item));
    }
    return csv_cont;
  };

  addSummaryRows = (rows) => {
    if (!rows || rows.length === 0) return [];

    // Use the first row's keys as the column order
    const keys = Object.keys(rows[0]);

    function sumRows(type) {
      const filtered = rows.filter(row => row.Type === type);
      const summary = {};
      keys.forEach(key => {
        if (['Flight', 'Date', 'Segment', 'Type'].includes(key)) return;
        summary[key] = filtered.reduce((acc, row) => {
          const val = row[key];
          return acc + (val !== undefined && val !== null && val !== '' && !isNaN(val) ? parseFloat(val) : 0);
        }, 0);
      });
      summary.Flight = type === 'Inbound' ? 'Import' : 'Export';
      summary.Date = '';
      summary.Segment = '';
      summary.Type = type;
      // Ensure column order and fill missing columns with 0
      return keys.reduce((acc, key) => {
        acc[key] = summary[key] !== undefined ? summary[key] : 0;
        return acc;
      }, {});
    }

    // Add Total row (sum all rows)
    const totalRow = {};
    keys.forEach(key => {
      if (['Flight', 'Date', 'Segment', 'Type'].includes(key)) return;
      totalRow[key] = rows.reduce((acc, row) => {
        const val = row[key];
        return acc + (val !== undefined && val !== null && val !== '' ? parseFloat(val) || 0 : 0);
      }, 0);
    });
    totalRow.Flight = 'Total';
    totalRow.Date = '';
    totalRow.Segment = '';
    totalRow.Type = '';
    // Ensure column order
    const totalRowOrdered = keys.reduce((acc, key) => {
      acc[key] = totalRow[key] !== undefined ? totalRow[key] : '';
      return acc;
    }, {});

    // Find first inbound and outbound row indexes
    const firstInboundIdx = rows.findIndex(row => row.Type === 'Inbound');
    const firstOutboundIdx = rows.findIndex(row => row.Type === 'Outbound');

    const result = [...rows];

    if (firstInboundIdx !== -1) {
      result.splice(firstInboundIdx, 0, sumRows('Inbound'));
    }
    if (firstOutboundIdx !== -1) {
      const offset = firstInboundIdx !== -1 && firstOutboundIdx > firstInboundIdx ? 1 : 0;
      result.splice(firstOutboundIdx + offset, 0, sumRows('Outbound'));
    }

    // Insert Total row at the top
    result.unshift(totalRowOrdered);

    return result;
  };

  get_service_logs_csv = async () => {
    let daylogdata = this.state.daylogdata || [];
    let monthlogdata = this.state.monthlogdata || [];
    // Only finalized logs
    daylogdata = daylogdata.filter(row => row.status !== 'Not Finalized');
    monthlogdata = monthlogdata.filter(row => row.status !== 'Not Finalized');
    // Helper to flatten contractData for each log
    function flattenContractData(contractData, notes) {
      const result = {};
      contractData.forEach(item => {
        // Use item.label as column prefix
        result[`${item.label.charAt(0).toUpperCase() + item.label.slice(1)} (Quantity)`] = item.quantity;
        // Add more fields if needed
        const filteredNotes = notes.filter(note => note.cont_rowId === item.cont_rowId);
        // set column name as notes and put data comma separated
        result[`${item.label.charAt(0).toUpperCase() + item.label.slice(1)} (Notes)`] = filteredNotes.map(n => n.note).join(', ');
      });
      return result;
    }

    // Build rows for Excel
    let csvRows = [];
    daylogdata.forEach(log => {
      let row = {
        'Label': log.label,
        'Type': log.type,
        ...flattenContractData(log.contractData, log.notes)
      };
      csvRows.push(row);
    });

    monthlogdata.forEach(log => {
      let row = {
        'Label': log.label,
        'Type': log.type,
        ...flattenContractData(log.contractData, log.notes)
      };
      csvRows.push(row);
    });
    return csvRows;
  };

  get_csv_stat = async () => {
    let csv_stat = [];
    this.state.billingData.map((column) => {
      csv_stat = [];
      let data = {
        'Lable': column?.ex_label,
        'Date': '',
        'Sch Arr Date': '',
        'Sch Dept Date': '',
        'Act Arr Date': '',
        'Act Dept Date': '',
        'Flight': column?.flight_count,

      };
      this.state.billingColumns.map((c) => {
        let field = c.field;
        // if (this.state.billingFields.exclude_disc) {
        //   field = field.replace('_disc', '');
        // }
        data[c.headerName] = column?.[field];
      });
      csv_stat.push(data);
      data = {};
      data = {
        'Lable': column?.inbound?.ex_label,
        'Date': '',
        'Sch Arr Date': '',
        'Sch Dept Date': '',
        'Act Arr Date': '',
        'Act Dept Date': '',
        'Flight': column?.inbound?.flight_count,
      };
      this.state.billingColumns.map((c) => {
        let field = c.field;
        // if (this.state.billingFields.exclude_disc) {
        //   field = field.replace('_disc', '');
        // }
        data[c.headerName] = column?.inbound?.[field];
      });
      csv_stat.push(data);
      //inbound flights
      if (column?.inbound?.flights?.length > 0) {
        column?.inbound?.flights.map((flight) => {
          data = {};
          data = {
            'Lable': flight.label?.split('/')?.[0],
            'Date': flight.label?.split('/')?.[1],
            'Sch Arr Date': flight.schdl_arr ? getStationDate( flight.dest,flight.schdl_arr, 'DDMMMYY') : '',
            'Sch Dept Date': flight.schdl_dept ? getStationDate( flight.org,flight.schdl_dept, 'DDMMMYY') : '',
            'Act Arr Date': flight.act_arr ? getStationDate( flight.dest,flight.act_arr, 'DDMMMYY') : '',
            'Act Dept Date': flight.act_dept ? getStationDate( flight.org,flight.act_dept, 'DDMMMYY') : '',
            'Flight': flight.flight_count,
          };
          this.state.billingColumns.map((c) => {
            let field = c.field;
            // if (this.state.billingFields.exclude_disc) {
            //   field = field.replace('_disc', '');
            // }
            data[c.headerName] = flight[field];
          });
          csv_stat.push(data);
        });
      }
      data = {};
      data = {
        'Lable': column?.outbound?.ex_label,
        'Date': '',
        'Sch Arr Date': '',
        'Sch Dept Date': '',
        'Act Arr Date': '',
        'Act Dept Date': '',
        'Flight': column?.outbound?.flight_count,
      };
      this.state.billingColumns.map((c) => {
        let field = c.field;
        // if (this.state.billingFields.exclude_disc) {
        //   field = field.replace('_disc', '');
        // }
        data[c.headerName] = column?.outbound?.[field];
      });
      csv_stat.push(data);
      //outbound flights
      if (column?.outbound?.flights?.length > 0) {
        column?.outbound?.flights.map((flight) => {
          data = {};
          data = {
            'Lable': flight.label?.split('/')?.[0],
            'Date': flight.label?.split('/')?.[1],
            'Sch Arr Date': flight.schdl_arr ? getStationDate( flight.dest,flight.schdl_arr, 'DDMMMYY') : '',
            'Sch Dept Date': flight.schdl_dept ? getStationDate( flight.org,flight.schdl_dept, 'DDMMMYY') : '',
            'Act Arr Date': flight.act_arr ? getStationDate( flight.dest,flight.act_arr, 'DDMMMYY') : '',
            'Act Dept Date': flight.act_dept ? getStationDate( flight.org,flight.act_dept, 'DDMMMYY') : '',
            'Flight': flight.flight_count,
          };
          this.state.billingColumns.map((c) => {
            let field = c.field;
            // if (this.state.billingFields.exclude_disc) {
            //   field = field.replace('_disc', '');
            // }
            data[c.headerName] = flight[field];
          });
          csv_stat.push(data);
        });
      }
    });
    return csv_stat;
  };

  // handleExport = async () => {
  //   const state = { ...this.state };
  //   let csv_discdetails = [{}];
  //   let csv_contract = [{}];
  //   let csv_stat = [{}];
  //   let csv_disc = [{}];
  //   let csv_invoice = [{}];
  //   let csv_flightsummary =  [{}];
  //   let csv_flightdetails =  [{}];
  //   let tonngage_summary = [{}];
  //   let csv_servicelogs = [{}];
  //   this.fetchInvoiceData(false, async (status) => {
  //     if (status) {
  //       if (this.state.contractData && this.state.contractData.length > 0) {
  //         csv_contract = this.state.contractData.filter(item => item.is_nonbillable !== true).map((row) => {
  //           return {
  //             'Item': row.item,
  //             'Driver': row.driver,
  //             'Source': row.source,
  //             'Quantity': this.state.billingFields.exclude_disc ? row.quantity : row.dis_quantity,
  //           };
  //         });
  //         csv_invoice = await this.get_csv_cont() || [{}];
  //         csv_flightsummary = await this.get_csvpage_cont('Flight Summary') || [{}];
  //         csv_flightdetails = await this.get_csvpage_cont('Flight Details') || [{}];
  //         tonngage_summary = await this.get_tonnage_summary() || [{}];
  //         csv_servicelogs = await this.get_service_logs_csv() || [{}];

  //         //add missing labels from rows in csv_flightsummary and csv_flightdetails
  //         // Get all unique keys from all rows
  //         const allKeys1 = Array.from(
  //           new Set(csv_flightsummary.flatMap(row => Object.keys(row)))
  //         );
  //         // Normalize each row to have all keys, filling missing values with 0
  //         csv_flightsummary = csv_flightsummary.map(row => {
  //           const normalized = {};
  //           allKeys1.forEach(key => {
  //             // Keep original value if present, else set to 0 (except for Flight, Date, Segment, Type)
  //             if (['Flight', 'Segment', 'Type'].includes(key)) {
  //               normalized[key] = row[key] !== undefined ? row[key] : '';
  //             } else {
  //               normalized[key] = row[key] !== undefined ? row[key] : 0;
  //             }
  //           });
  //           return normalized;
  //         });
  //         const allKeys2 = Array.from(
  //           new Set(csv_flightdetails.flatMap(row => Object.keys(row)))
  //         );
  //         // Normalize each row to have all keys, filling missing values with 0
  //         csv_flightdetails = csv_flightdetails.map(row => {
  //           const normalized = {};
  //           allKeys2.forEach(key => {
  //             // Keep original value if present, else set to 0 (except for Flight, Date, Segment, Type)
  //             if (['Flight', 'Date', 'Segment', 'Type'].includes(key)) {
  //               normalized[key] = row[key] !== undefined ? row[key] : '';
  //             } else {
  //               normalized[key] = row[key] !== undefined ? row[key] : 0;
  //             }
  //           });
  //           return normalized;
  //         });

  //         // Usage before filtering with fs_labels:
  //         csv_flightsummary = await this.addSummaryRows(csv_flightsummary);
  //         csv_flightsummary = csv_flightsummary.map(row => {
  //           const { Date: _Date, ...rest } = row;
  //           return rest;
  //         });
  //         csv_flightdetails = await this.addSummaryRows(csv_flightdetails);
  //       }
  //     }
  //     this.setState({
  //       flightList: [],
  //       billingData: [],
  //       filteredData: [],
  //       contractData: [],
  //       accord_id: null,
  //       accord_type: null,
  //     });
  //     this.fetchProducts(async (status) => {
  //       if (status) {
  //         csv_stat = await this.get_csv_stat() || [{}];
  //       }
  //       this.setState({
  //         flightList: [],
  //         billingData: [],
  //         filteredData: [],
  //         contractData: [],
  //         accord_id: null,
  //         accord_type: null,
  //       });
  //       this.fetchDiscrepancies(null, async (status) => {
  //         if (status) {
  //           if (this.state.billingData.length > 0) {
  //             csv_disc = [];
  //             discrepancyType.map((type) => {
  //               csv_disc.push({
  //                 'Type': type,
  //                 'Total': this.state.billingData[0][type],
  //                 'Inbound': this.state.billingData[0]?.inbound[type],
  //                 'Outbound': this.state.billingData[0]?.outbound[type]
  //               });
  //             });
  //           }

  //           if (this.state.flightList.length > 0) {
  //             let inbound_data = this.state.flightList[0].inbound || [];
  //             let outbound_data = this.state.flightList[0].outbound || [];
  //             await Promise.all(inbound_data.map(async (flight) => {
  //               if(flight?.flight_discrepancies && flight.flight_discrepancies.length > 0){
  //                 flight.flight_discrepancies.map((disc) => {
  //                   csv_discdetails.push({
  //                     'Flight': '' + this.state.flightList[0].code + flight.flight_no,
  //                     'Date': flight?.flight_date,
  //                     'Type': 'Inbound',
  //                     'Discrepancy Type': disc.type,
  //                     'ULD Number': disc.uld_no,
  //                     'Handled As': disc.handled_as,
  //                     'Segment': disc.segment === 'null' ? '' : disc.segment,
  //                     'ULD Type': disc.uld_type === 'null' ? '' : disc.uld_type,
  //                     'AWB Number': disc.awb_no,
  //                     'Org' : disc.org,
  //                     'Dest': disc.dest,
  //                     'Total Pcs' : disc.t_pcs,
  //                     'Total Wgt' : disc.t_wgt,
  //                     'Dscpy Pcs' : disc.d_pcs,
  //                     'Dscpy Wgt' : disc.d_wgt,
  //                     'Remarks': disc.description,
  //                   });
  //                 });
  //               }
  //             }));
  //             await Promise.all(outbound_data.map(async (flight) => {
  //               if(flight?.flight_discrepancies && flight.flight_discrepancies.length > 0){
  //                 flight.flight_discrepancies.map((disc) => {
  //                   csv_discdetails.push({
  //                     'Flight': '' + this.state.flightList[0].code + flight.flight_no,
  //                     'Date': flight?.flight_date,
  //                     'Type': 'Outbound',
  //                     'Discrepancy Type': disc.type,
  //                     'ULD Number': disc.uld_no,
  //                     'Handled As': disc.handled_as,
  //                     'Segment': disc.segment === 'null' ? '' : disc.segment,
  //                     'ULD Type': disc.uld_type === 'null' ? '' : disc.uld_type,
  //                     'AWB Number': disc.awb_no,
  //                     'Org' : disc.org,
  //                     'Dest': disc.dest,
  //                     'Total Pcs' : disc.t_pcs,
  //                     'Total Wgt' : disc.t_wgt,
  //                     'Dscpy Pcs' : disc.d_pcs,
  //                     'Dscpy Wgt' : disc.d_wgt,
  //                     'Remarks': disc.description,
  //                   });
  //                 });
  //               }
  //             }));
  //           }
  //         }

  //         const allKeys1 = Array.from(
  //           new Set(tonngage_summary.flatMap(row => Object.keys(row)))
  //         );

  //         const allKeys2 = Array.from(
  //           new Set(csv_flightsummary.flatMap(row => Object.keys(row)))
  //         );
  //         const allKeys3 = Array.from(
  //           new Set(csv_flightdetails.flatMap(row => Object.keys(row)))
  //         );
  //         const allKeys8 = Array.from(
  //           new Set(csv_discdetails.flatMap(row => Object.keys(row)))
  //         );
  //         const allKeys4 = Array.from(
  //           new Set(csv_contract.flatMap(row => Object.keys(row)))
  //         );
  //         const allKeys5 = Array.from(
  //           new Set(csv_stat.flatMap(row => Object.keys(row)))
  //         );
  //         const allKeys6 = Array.from(
  //           new Set(csv_disc.flatMap(row => Object.keys(row)))
  //         );
  //         const allKeys7 = Array.from(
  //           new Set(csv_invoice.flatMap(row => Object.keys(row)))
  //         );
  //         const allKeys9 = Array.from(
  //           new Set(csv_servicelogs.flatMap(row => Object.keys(row)))
  //         );

  //         // const worksheet1 = XLSX.utils.json_to_sheet(csv_contract, { header: Object.keys(csv_contract?.[0]) });
  //         // const worksheet2 = XLSX.utils.json_to_sheet(csv_stat, { header: Object.keys(csv_stat[0]) });
  //         // const worksheet3 = XLSX.utils.json_to_sheet(csv_disc, { header: Object.keys(csv_disc[0]) });
  //         // const worksheet4 = XLSX.utils.json_to_sheet(csv_invoice, { header: Object.keys(csv_invoice[0]) });
  //         // const worksheet5 = XLSX.utils.json_to_sheet(csv_flightsummary, { header: Object.keys(csv_flightsummary[0]) });
  //         // const worksheet6 = XLSX.utils.json_to_sheet(csv_flightdetails, { header: Object.keys(csv_flightdetails[0]) });
  //         const worksheet1 = XLSX.utils.json_to_sheet(tonngage_summary, { header: allKeys1 });
  //         const worksheet2 = XLSX.utils.json_to_sheet(csv_flightsummary, { header: allKeys2 });
  //         const worksheet3 = XLSX.utils.json_to_sheet(csv_flightdetails, { header: allKeys3 });
  //         const worksheet8 = XLSX.utils.json_to_sheet(csv_discdetails, { header: allKeys8 });
  //         const worksheet4 = XLSX.utils.json_to_sheet(csv_contract, { header: allKeys4 });
  //         const worksheet5 = XLSX.utils.json_to_sheet(csv_stat, { header: allKeys5 });
  //         const worksheet6 = XLSX.utils.json_to_sheet(csv_disc, { header: allKeys6 });
  //         const worksheet7 = XLSX.utils.json_to_sheet(csv_invoice, { header: allKeys7 });
  //         const worksheet9 = XLSX.utils.json_to_sheet(csv_servicelogs, { header: allKeys9 });

  //         worksheet1['!cols'] = allKeys1.map(key => {
  //           const maxLen = Math.max(
  //             key.length,
  //             ...tonngage_summary.map(row => (row[key] ? String(row[key]).length : 0))
  //           );
  //           return { wch: maxLen + 2 };
  //         });

  //         // Set column widths for worksheet2
  //         worksheet2['!cols'] = [
  //           { wch: Math.round(7.45 * 3.78) }, // Column A
  //           ...Array(allKeys2.length - 1).fill({ wch: Math.round(2.62 * 3.78) }) // Other columns
  //         ];
  //         // Set wrap text for all cells in Row 1 (header) of worksheet2
  //         const range2 = XLSX.utils.decode_range(worksheet2['!ref']);
  //         for (let C = range2.s.c; C <= range2.e.c; ++C) {
  //           const cellAddress = XLSX.utils.encode_cell({ 
  //             r: 0, 
  //             c: C 
  //           });
  //           if (worksheet2[cellAddress]) {
  //             worksheet2[cellAddress].s = worksheet2[cellAddress].s || {};
  //             worksheet2[cellAddress].s.alignment = worksheet2[cellAddress].s.alignment || {};
  //             worksheet2[cellAddress].s.alignment.wrapText = true;
  //           }
  //         }
  //         // Set background color for "Total", "Import", "Export" rows in worksheet2
  //         for (let R = range2.s.r; R <= range2.e.r; ++R) {
  //           const cellA = XLSX.utils.encode_cell({ 
  //             r: R, 
  //             c: 0 
  //           }); // Column A
  //           const valueA = worksheet2[cellA]?.v;
  //           let fillColor = null;
  //           if (valueA === 'Total') fillColor = 'FFC000';
  //           if (valueA === 'Import' || valueA === 'Export') fillColor = 'FFFF00';

  //           if (fillColor) {
  //             for (let C = 0; C < allKeys2.length; ++C) {
  //               const cellAddress = XLSX.utils.encode_cell({ 
  //                 r: R, 
  //                 c: C 
  //               });
  //               if (!worksheet2[cellAddress]) {
  //                 worksheet2[cellAddress] = { 
  //                   t: 's', 
  //                   v: '' 
  //                 };
  //               }
  //               worksheet2[cellAddress].s = worksheet2[cellAddress].s || {};
  //               worksheet2[cellAddress].s.fill = {
  //                 patternType: 'solid',
  //                 fgColor: { rgb: fillColor }
  //               };
  //             }
  //           }
  //         }
  //         // Set Row 1 height for worksheet2
  //         worksheet2['!rows'] = worksheet2['!rows'] || [];
  //         worksheet2['!rows'][0] = { hpt: 1.69 * 28.35 };

  //         // Set column widths for worksheet3
  //         worksheet3['!cols'] = [
  //           { wch: Math.round(7.45 * 3.78) }, // Column A
  //           ...Array(allKeys3.length - 1).fill({ wch: Math.round(2.62 * 3.78) }) // Other columns
  //         ];
  //         // Set wrap text for all cells in Row 1 (header) of worksheet3
  //         const range = XLSX.utils.decode_range(worksheet3['!ref']);
  //         // Set wrap text for all cells in Column A
  //         for (let C = range.s.c; C <= range.e.c; ++C) {
  //           const cellAddress = XLSX.utils.encode_cell({ 
  //             r: 0, 
  //             c: C 
  //           }); // Row 1 = r:0
  //           if (worksheet3[cellAddress]) {
  //             worksheet3[cellAddress].s = worksheet3[cellAddress].s || {};
  //             worksheet3[cellAddress].s.alignment = worksheet3[cellAddress].s.alignment || {};
  //             worksheet3[cellAddress].s.alignment.wrapText = true;
  //           }
  //         }
  //         for (let R = range.s.r; R <= range.e.r; ++R) {
  //           const cellA = XLSX.utils.encode_cell({ 
  //             r: R, 
  //             c: 0 
  //           }); // Column A
  //           const valueA = worksheet3[cellA]?.v;
  //           let fillColor = null;
  //           if (valueA === 'Total') fillColor = 'FFC000';
  //           if (valueA === 'Import' || valueA === 'Export') fillColor = 'FFFF00';

  //           if (fillColor) {
  //             for (let C = 0; C < allKeys3.length; ++C) { // Use allKeys3.length for full column coverage
  //               const cellAddress = XLSX.utils.encode_cell({ 
  //                 r: R, 
  //                 c: C 
  //               });
  //               // Create cell if missing, so color is applied even to empty cells
  //               if (!worksheet3[cellAddress]) {
  //                 worksheet3[cellAddress] = { 
  //                   t: 's', 
  //                   v: '' 
  //                 };
  //               }
  //               worksheet3[cellAddress].s = worksheet3[cellAddress].s || {};
  //               worksheet3[cellAddress].s.fill = {
  //                 patternType: 'solid',
  //                 fgColor: { rgb: fillColor }
  //               };
  //             }
  //           }
  //         }
  //         // Set Row 1 height (cm to Excel's 'hpt' units: 1 cm ≈ 28.35 hpt)
  //         worksheet3['!rows'] = worksheet3['!rows'] || [];
  //         worksheet3['!rows'][0] = { hpt: 1.69 * 28.35 };
          
  //         worksheet8['!cols'] = allKeys8.map(key => {
  //           const maxLen = Math.max(
  //             key.length,
  //             ...csv_discdetails.map(row => (row[key] ? String(row[key]).length : 0))
  //           );
  //           return { wch: maxLen + 2 };
  //         });

  //         worksheet4['!cols'] = allKeys4.map(key => {
  //           const maxLen = Math.max(
  //             key.length,
  //             ...csv_contract.map(row => (row[key] ? String(row[key]).length : 0))
  //           );
  //           return { wch: maxLen + 2 };
  //         });
  //         worksheet5['!cols'] = allKeys5.map(key => {
  //           const maxLen = Math.max(
  //             key.length,
  //             ...csv_stat.map(row => (row[key] ? String(row[key]).length : 0))
  //           );
  //           return { wch: maxLen + 2 };
  //         });
  //         worksheet6['!cols'] = allKeys6.map(key => {
  //           const maxLen = Math.max(
  //             key.length,
  //             ...csv_disc.map(row => (row[key] ? String(row[key]).length : 0))
  //           );
  //           return { wch: maxLen + 2 };
  //         });
  //         worksheet7['!cols'] = allKeys7.map(key => {
  //           const maxLen = Math.max(
  //             key.length,
  //             ...csv_invoice.map(row => (row[key] ? String(row[key]).length : 0))
  //           );
  //           return { wch: maxLen + 2 };
  //         });
          
  //         worksheet9['!cols'] = allKeys9.map(key => {
  //           const maxLen = Math.max(
  //             key.length,
  //             ...csv_servicelogs.map(row => (row[key] ? String(row[key]).length : 0))
  //           );
  //           return { wch: maxLen + 2 };
  //         });

  //         // // header bold
  //         // worksheet1['!rows'] = [{ bold: true }];

  //         // worksheet1['!cols'] = [
  //         //   { wch: 50 },
  //         //   { wch: 20 },
  //         //   { wch: 20 },
  //         // ];
  //         // worksheet2['!cols'] = [
  //         //   { wch: 30 },
  //         //   { wch: 10 },
  //         //   { wch: 10 },
  //         //   { wch: 10 },
  //         //   { wch: 10 },
  //         //   { wch: 10 },
  //         //   { wch: 10 },
  //         //   { wch: 10 },
  //         //   { wch: 10 },
  //         //   { wch: 10 },
  //         //   { wch: 10 },
  //         //   { wch: 10 },
  //         //   { wch: 10 },
  //         //   { wch: 10 },
  //         //   { wch: 10 },
  //         //   { wch: 10 },
  //         //   { wch: 10 },
  //         //   { wch: 10 },
  //         //   { wch: 10 },
  //         //   { wch: 10 },
  //         //   { wch: 10 },
  //         // ];

  //         // worksheet3['!cols'] = [
  //         //   { wch: 30 },
  //         //   { wch: 10 },
  //         //   { wch: 10 },
  //         //   { wch: 10 },
  //         // ];

  //         // worksheet4['!cols'] = [
  //         //   { wch: 10 },
  //         //   { wch: 20 },
  //         //   { wch: 20 },
  //         //   { wch: 20 },
  //         //   { wch: 20 },
  //         //   { wch: 20 },
  //         //   { wch: 20 },
  //         //   { wch: 20 },
  //         //   { wch: 20 },
  //         //   { wch: 20 },
  //         //   { wch: 20 },
  //         //   { wch: 20 },
  //         //   { wch: 20 },
  //         //   { wch: 20 },
  //         // ];

  //         const workbook = XLSX.utils.book_new();
  //         XLSX.utils.book_append_sheet(workbook, worksheet1, 'Tonnage Summary');
  //         XLSX.utils.book_append_sheet(workbook, worksheet2, 'Flight Summary');
  //         XLSX.utils.book_append_sheet(workbook, worksheet3, 'Flight Details');
  //         XLSX.utils.book_append_sheet(workbook, worksheet8, 'Discrepancy Details');
  //         // XLSX.utils.book_append_sheet(workbook, worksheet4, 'Contract Data');
  //         XLSX.utils.book_append_sheet(workbook, worksheet5, 'Statistics');
  //         // XLSX.utils.book_append_sheet(workbook, worksheet6, 'Discrepancy');
  //         // XLSX.utils.book_append_sheet(workbook, worksheet7, 'Invoice');
  //         XLSX.utils.book_append_sheet(workbook, worksheet9, 'Service Logs Details');

  //         // Generate XLSX file and trigger download
  //         const excelBuffer = XLSX.write(workbook, {
  //           bookType: 'xlsx',
  //           type: 'array',
  //           cellStyles: true
  //         });
  //         const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
  //         saveAs(blob, 'Flight Load Info.xlsx');
  //         this.setState({ ...state });
  //       });
  //     });
  //   });
  // };

  handleModalOpen = () => {
    this.setState({ modalOpen: true });
  };

  handleModalClose = () => {
    this.setState({ modalOpen: false });
  };

  handleFlight = (type, data) => {
    this.setState({
      modalOpen: true,
      flightReportData: data.id
    });
  };

  progressCount = () => {
    this.setState((prevState) => {
      if (prevState.progress >= 100) {
        clearInterval(this.progressInterval);
        this.progressInterval = null; 
        return null; 
      }
      return { progress: prevState.progress + 10 };
    });
  };


  showHideOneOff = (e) => {
    this.setState({ showOneOff: e.target.checked });
  };
  fetchOneOff = () => {
    // GET /oneoff , invoice_dt
    http.get(`/oneoff?invoice_dt=${this.state.searchFields.month}&airline=${this.state.searchFields?.airline}&contract_type=${this.state.contract_Type}`)
      .then((response) => {
        this.setState({ oneOffData: response.data.data });
      });
  };
  editOneOff = (index, record) => {  // populate oneOffEdit
    this.setState({
      oneOffEdit: {
        ...record,
        index
      }
    });
  };
  deleteOneOff = (index, record) => {
    console.log('deleteOneOff', index, record);

  };
  clearOneOff = () => {
    this.setState({
      oneOffEdit: {
        index: null,
        id: null,
        label: '',
        amount: '',
        operation: '',
        cycle: '',
      }
    });
  };
  handleOneOffChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let oneOffEdit = this.state.oneOffEdit;
    oneOffEdit[name] = value;
    this.setState({ oneOffEdit });
  };
  updateOneOff = () => {
    let records = [];

    let id = null;
    if (this.state.oneOffData && this.state.oneOffData[0]) {
      id = this.state.oneOffData[0]?.id;
      records = this.state.oneOffData[0]?.records;
    }
    if (this.state.oneOffEdit.index !== null && this.state.oneOffEdit.index !== undefined) {
      records[this.state.oneOffEdit.index] = {
        label: this.state.oneOffEdit.label,
        amount: this.state.oneOffEdit.amount,
        operation: this.state.oneOffEdit.operation,
        cycle: this.state.oneOffEdit.cycle,
      };
    } else {
      records.push({
        label: this.state.oneOffEdit.label,
        amount: this.state.oneOffEdit.amount,
        operation: this.state.oneOffEdit.operation,
        cycle: this.state.oneOffEdit.cycle,
      });
    }
    http.post('/updateOneoff', {
      invoice_dt: this.state.searchFields.month,
      id: id || null,
      records: records,
      airlineId: this.state.searchFields?.airline,
      contract_type: this.state.contract_Type,
    })
      .then((response) => {
        this.setState({
          oneOffData: [response.data.data],
          oneOffEdit: {
            index: null,
            id: null,
            label: '',
            amount: '',
            operation: '',
            cycle: '',
          }
        });
      });
  };
  startTimer = () => {
    if(cookies.get('expiryTimer')) {
      this.timer = setInterval(() => {
        // cookies.remove('expiryTimer', { path: '/' });
        this.setState({ sessionExpired: true });
        this.stopInterval();
      }, 7200000); // 2hrs
    }
  };
  stopInterval = () => {
    clearInterval(this.timer);
    cookies.remove('expiryTimer', { path: '/' });
  };

  handleTableCollapse = (id) => {
    let collapse = this.state.collapse;
    if(collapse.includes(id)) {
      const index = collapse.indexOf(id);
      if (index > -1) { 
        collapse.splice(index, 1);
      }
    }
    else collapse.push(id);
    this.setState({ collapse }); 
  };

  filter = () => {
    const { filterData } = this.state;
    let filteredBillingData = cloneDeep(this.state.billingData);
    let expanded = '';
    if (filterData.search) {
      const searchValue = filterData?.search.toLowerCase();
      const inboundMatches = filteredBillingData[0].inbound.flights.filter(item => item?.label?.toLowerCase().includes(searchValue));
      const outboundMatches = filteredBillingData[0].outbound.flights.filter(item => item?.label?.toLowerCase().includes(searchValue));
      if (inboundMatches.length > 0 && outboundMatches.length === 0) {
        filteredBillingData[0].inbound.flights = inboundMatches;
        filteredBillingData[0].outbound.flights = [];
        expanded = 'inbound';
      } else if (outboundMatches.length > 0 && inboundMatches.length === 0) {
        filteredBillingData[0].outbound.flights = outboundMatches;
        filteredBillingData[0].inbound.flights = [];
        expanded = 'outbound';
      } else if (inboundMatches.length > 0 && outboundMatches.length > 0) {
        filteredBillingData[0].inbound.flights = inboundMatches;
        filteredBillingData[0].outbound.flights = outboundMatches;
        expanded = 'none';
      } else {
        filteredBillingData[0].inbound.flights = [];
        filteredBillingData[0].outbound.flights = [];
        expanded = 'none';
      }
    }
    this.setState({
      filteredBillingData,
      expandedFlight: filterData.search ? 'flight' : '',
      expanded: expanded,
    });
  };

  handleFilterChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      filterData: {
        ...(this.state.filterData || {}),
        [name]: value
      }
    }, () => {
      this.filter();
    });
  };

  handleReportChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState((prev) => ({
      reportFields: {
        ...prev.reportFields,
        [name]: value
      }
    }));
  };

  onModalOpen = (modal) => {
    this.setState({ modal });
  };

  onModalClose = () => {
    this.setState({ modal: false });
  };

  handleCustomReportSelect = (type, value) => {
    if (type === 'Tonnage Summary') {
      this.setState({ tonSumOpts: value } );
    } else if (type === 'Flight Summary') {
      this.setState({ flightSumOpts: value } );
    } else if (type === 'Flight Details') {
      this.setState({ flightDetOpts: value } );
    }
  };

  handleEmailPassword = () => {
    this.setState({ emailPassword: true });
  };

  showTransitAWBs = (contractLabel, contractQty, contractEqualizedQty) => {
    // console.log('showTransitAWBsccccccccccccccccccccccccccccccccccccccc', contractLabel, contractQty, contractEqualizedQty);
    this.setState({ 
      transitAWBsModal: true,
      contractLabel: contractLabel,
      contractQty: contractQty,
      contractEqualizedQty: contractEqualizedQty,
    });
  };

  hideTransitAWBs = () => {
    this.setState({ 
      transitAWBsModal: false,
      contractLabel: '',
      contractQty: 0,
      contractEqualizedQty: 0,
    });
  };

  handleTransitAwbChange = (e) => {
    const { value } = e.target;
    this.setState({ transitAWBType: value });
  };

  render() {
    // const { difference } = this.state;
    return (
      <>
        {/* <BillingReport
          modal={this.state.modal}
          action={this.state.action}
          handleOpen={this.handleOpen}
          onClose={this.onClose}
          flightList={this.state.flightList}
          onFilterMain={this.onFilterMain}
          // generateBillingReport={this.generateBillingReport}
          changeCheck={this.changeCheck}
          onChange={this.onChange}
          changeDateTime={this.changeDateAndTime}
          flightFields={this.state.flightFields}
          flightErrors={this.state.flightErrors}
          searchFields={this.state.searchFields}
          airlines={this.state.airlines}
          addFlight={this.addFlight}
          editFlight={this.editFlight}
          flightData={this.state.flightData}
          stations={this.props.stations}
          handleDelete={this.handleDelete}
          stationCode={this.station_code}
          openFlightsFolder={this.openFlightsFolder}
          flightDetails={this.state.flightDetails}
          flightID={this.state.flightID}
          showflightDetails={this.state.showflightDetails}
          flightStatus={this.state.flightStatus}
          billingData={this.state.billingData}
          filteredData={this.state.filteredData}
          billingColumns={this.state.billingColumns}

          billingFields={this.state.billingFields}
        /> */}
        <FlightLoadInfo
          manifestDate={this.state.manifestDate}
          billingExists={this.state.billingExists}
          genInvProgress={this.props.genInvProgress}
          modal={this.state.modal}
          action={this.state.action}
          handleOpen={this.handleOpen}
          onClose={this.onClose}
          // handleExport={this.handleExport}
          handleExport={() =>
            handleExport(
              this.state.contractData,
              this.state.billingFields,
              this.state.billingData,
              this.state.flightList,
              this.state.csvContracts,
              this.state.reportFields,
              this.state.flightSumOpts,
              this.state.flightDetOpts,
              this.state.tonSumOpts,
              this.state.daylogdata, 
              this.state.monthlogdata,
              this.state.billingColumns,
              {
                ...this.state.searchFields,
                airlineCode: this.state.airlineCode,
                logo: this.state.airlines.find(a => a.code === this.state.airlineCode)?.logo
              },
              this.fetchInvoiceData.bind(this),
              this.fetchProducts.bind(this),
              this.fetchDiscrepancies.bind(this),
              this.state.invoicedata,
              this.state.statisticsSummary
            )
          }
          // onFilterMain={this.onFilterMain}
          // generateBillingReport={this.generateBillingReport}
          changeCheck={this.changeCheck}
          onChange={this.onChange}
          changeDateTime={this.changeDateAndTime}
          flightFields={this.state.flightFields}
          flightErrors={this.state.flightErrors}
          searchFields={this.state.searchFields}
          cont_item={this.state.cont_item}
          airlines={this.state.airlines}
          combinationAirline={this.state.combinationAirline}
          airlineCode={this.state.airlineCode}
          addFlight={this.addFlight}
          editFlight={this.editFlight}
          flightData={this.state.flightData}
          stations={this.props.stations}
          handleDelete={this.handleDelete}
          stationCode={this.station_code}
          openFlightsFolder={this.openFlightsFolder}
          flightDetails={this.state.flightDetails}
          flightID={this.state.flightID}
          showflightDetails={this.state.showflightDetails}
          flightStatus={this.state.flightStatus}
          billingData={this.state.billingData}
          filteredData={this.state.filteredData}
          billingColumns={this.state.billingColumns}
          billingFields={this.state.billingFields}


          handleChange={this.handleChange}
          expanded={this.state.expanded}
          handleToggle={this.handleToggle}
          loadInfo={this.state.loadInfo}

          handleContractType={this.handleContractType}
          contract_Type={this.state.contract_Type}
          setContTBData={this.setContTBData}
          flightdata={this.state.flightdata}
          daylogdata={this.state.daylogdata}
          monthlogdata={this.state.monthlogdata}
          alcontractsData={this.state.alcontractsData}
          contractData={this.state.contractData}
          transit_awbs={this.state.transit_awbs}
          transitAWBsModal={this.state.transitAWBsModal}
          contractLabel={this.state.contractLabel}
          contractQty={this.state.contractQty}
          contractEqualizedQty={this.state.contractEqualizedQty}
          dayContractData={this.state.dayContractData}
          monthContractData={this.state.monthContractData}
          invoice_info={this.state.invoice_info}
          accord_id={this.state.accord_id}
          accord_type={this.state.accord_type}
          summaryData={this.state.summaryData}
          showSummary={this.state.showSummary}
          billingCol={this.state.billingCol}

          fetchInvoiceData={this.fetchInvoiceData}
          triggerNewBilling={this.triggerNewBilling}
          triggerNewNewBilling={this.triggerNewNewBilling}
          handleModalOpen={this.handleModalOpen}
          modalOpen={this.state.modalOpen}
          handleModalClose={this.handleModalClose}
          handleFlight={this.handleFlight}
          flightReportData={this.state.flightReportData}
          discrepancyCount={this.state.discrepancyCount}

          showHideOneOff={this.showHideOneOff}
          showOneOff={this.state.showOneOff}
          updateOneOff={this.updateOneOff}
          editOneOff={this.editOneOff}
          deleteOneOff={this.deleteOneOff}
          clearOneOff={this.clearOneOff}
          oneOffEdit={this.state.oneOffEdit}
          handleOneOffChange={this.handleOneOffChange}

          oneOffData={this.state.oneOffData}
          oneOff={
            this.state.oneOffData && this.state.oneOffData[0]?.records
              ? this.state.oneOffData[0].records.map((record, index) => ({
                ...record,
                id: index + 1, // or any other logic to generate unique keys
              }))
              : []
          }

          handlePopover={this.handlePopover}
          closePopover={this.closePopover}
          popoverData={this.state.popoverData}
          handlePopoverClose={this.handlePopoverClose}
          anchorEl={this.state.anchorEl}
          progress={this.state.progress}

          expiryTimer={this.state.timer}
          sessionExpired={this.state.sessionExpired}
          startTimer={this.startTimer}
          stopInterval={this.stopInterval}
          emailPassword={this.state.emailPassword}
          handleEmailPassword={this.handleEmailPassword}

          handleTableCollapse={this.handleTableCollapse}
          collapse={this.state.collapse}
          filterData={this.state.filterData}
          filteredBillingData={this.state.filteredBillingData}
          handleFilterChange={this.handleFilterChange}
          reportFields={this.state.reportFields}
          handleReportChange={this.handleReportChange}
          onModalOpen={this.onModalOpen}
          onModalClose={this.onModalClose}
          customReportOptions={this.state.customReportOptions}

          handleCustomReportSelect={this.handleCustomReportSelect}
          tonSumOpts={this.state.tonSumOpts}
          flightSumOpts={this.state.flightSumOpts}
          flightDetOpts={this.state.flightDetOpts}
          expandedFlight={this.state.expandedFlight}
          showTransitAWBs= {this.showTransitAWBs}
          hideTransitAWBs= {this.hideTransitAWBs}
          handleTransitAwbChange={this.handleTransitAwbChange}
          transitAWBType={this.state.transitAWBType}
          statisticsSummary={this.state.statisticsSummary}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return { stations: state.stations };
};

const mapDispatchToProps = (dispatch) => {
  return { setDelete: (data) => dispatch(setDeleteAction(data)) };
};

// export default connect(mapStateToProps, mapDispatchToProps)(FlightLoadInfoContainer);
export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(forwardRef((props, ref) => <FlightLoadInfoContainer {...props} ref={ref} />));